(window.webpackJsonp=window.webpackJsonp||[]).push([[12],{
/***/"3OGf":
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return n}));
/* harmony import */var s=i("F3iu"),r=i("LDKE");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `vaadin-grid-templatizer` is a helper element for the `vaadin-grid` that is preparing and
 * stamping instances of cells and columns templates
 *
 * @extends PolymerElement
 * @private
 */
class n extends class extends s.a{}{static get is(){return"vaadin-grid-templatizer"}static get properties(){return{dataHost:Object,template:Object,_templateInstances:{type:Array,value:function(){return[]}},_parentPathValues:{value:function(){return{}}},_grid:Object}}static get observers(){return["_templateInstancesChanged(_templateInstances.*, _parentPathValues.*)"]}constructor(){super(),this._instanceProps={detailsOpened:!0,index:!0,item:!0,selected:!0,expanded:!0,level:!0}}createInstance(){this._ensureTemplatized();const e=new this._TemplateClass({});return this.addInstance(e),e}addInstance(e){-1===this._templateInstances.indexOf(e)&&(this._templateInstances.push(e),requestAnimationFrame(()=>this.notifyPath("_templateInstances.*",this._templateInstances)))}removeInstance(e){const t=this._templateInstances.indexOf(e);this.splice("_templateInstances",t,1)}_ensureTemplatized(){this._TemplateClass||(this._TemplateClass=Object(r.c)(this.template,this,{instanceProps:this._instanceProps,parentModel:!0,forwardHostProp:function(e,t){this._forwardParentProp(e,t),this._templateInstances&&this._templateInstances.forEach(i=>i.notifyPath(e,t))},notifyInstanceProp:function(e,t,i){if("index"===t||"item"===t)
// We don’t need a change notification for these.
return;const s=`__${t}__`;// Notify for only user-action changes, not for scrolling updates. E. g.,
// if `detailsOpened` is different from `__detailsOpened__`, which was set during render.
if(e[s]===i)return;e[s]=i;const r=Array.from(this._grid.$.items.children).filter(t=>this._grid._itemsEqual(t._item,e.item))[0];r&&Array.from(r.children).forEach(e=>{e._instance&&(e._instance[s]=i,e._instance.notifyPath(t,i))});if(Array.isArray(this._grid.items)&&0===t.indexOf("item.")){const s=this._grid.items.indexOf(e.item),r=t.slice("item.".length);this._grid.notifyPath(`items.${s}.${r}`,i)}const n=`_${t}InstanceChangedCallback`;this._grid&&this._grid[n]&&this._grid[n](e,i)}}))}_forwardParentProp(e,t){this._parentPathValues[e]=t,this._templateInstances.forEach(i=>i.notifyPath(e,t))}_templateInstancesChanged(e,t){let i,s;if("_templateInstances"===e.path)
// Iterate all instances
i=0,s=this._templateInstances.length;else{if("_templateInstances.splices"!==e.path)return;
// Iterate only new instances
i=e.value.index,s=e.value.addedCount}Object.keys(this._parentPathValues||{}).forEach(e=>{for(var t=i;t<i+s;t++)this._templateInstances[t].set(e,this._parentPathValues[e])})}}customElements.define(n.is,n)},
/***/"8+JU":
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return d}));
/**
@license
Copyright (c) 2019 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
const s="between",r="on-top-or-between",n="on-grid",a="on-top",o="above",l="below",h="empty",d=e=>class extends e{static get properties(){return{
/**
       * Defines the locations within the Grid row where an element can be dropped.
       *
       * Possible values are:
       * - `between`: The drop event can happen between Grid rows.
       * - `on-top`: The drop event can happen on top of Grid rows.
       * - `on-top-or-between`: The drop event can happen either on top of or between Grid rows.
       * - `on-grid`: The drop event will not happen on any specific row, it will show the drop target outline around the whole grid.
       * @attr {between|on-top|on-top-or-between|on-grid} drop-mode
       * @type {GridDropMode | null | undefined}
       */
dropMode:String,
/**
       * Marks the grid's rows to be available for dragging.
       * @attr {boolean} rows-draggable
       */
rowsDraggable:Boolean,
/**
       * A function that filters dragging of specific grid rows. The return value should be false
       * if dragging of the row should be disabled.
       *
       * Receives one argument:
       * - `model` The object with the properties related with
       *   the rendered item, contains:
       *   - `model.index` The index of the item.
       *   - `model.item` The item.
       *   - `model.expanded` Sublevel toggle state.
       *   - `model.level` Level of the tree represented with a horizontal offset of the toggle button.
       *   - `model.selected` Selected state.
       *
       * @type {GridDragAndDropFilter | null | undefined}
       */
dragFilter:Function,
/**
       * A function that filters dropping on specific grid rows. The return value should be false
       * if dropping on the row should be disabled.
       *
       * Receives one argument:
       * - `model` The object with the properties related with
       *   the rendered item, contains:
       *   - `model.index` The index of the item.
       *   - `model.item` The item.
       *   - `model.expanded` Sublevel toggle state.
       *   - `model.level` Level of the tree represented with a horizontal offset of the toggle button.
       *   - `model.selected` Selected state.
       *
       * @type {GridDragAndDropFilter | null | undefined}
       */
dropFilter:Function,
/** @private */
__dndAutoScrollThreshold:{value:50}}}static get observers(){return["_dragDropAccessChanged(rowsDraggable, dropMode, dragFilter, dropFilter, loading)"]}
/** @protected */ready(){super.ready(),this.$.table.addEventListener("dragstart",this._onDragStart.bind(this)),this.$.table.addEventListener("dragend",this._onDragEnd.bind(this)),this.$.table.addEventListener("dragover",this._onDragOver.bind(this)),this.$.table.addEventListener("dragleave",this._onDragLeave.bind(this)),this.$.table.addEventListener("drop",this._onDrop.bind(this)),this.$.table.addEventListener("dragenter",e=>{this.dropMode&&(e.preventDefault(),e.stopPropagation())})}
/** @private */_onDragStart(e){if(this.rowsDraggable){let t=e.target;if("vaadin-grid-cell-content"===t.localName&&(
// The draggable node is the cell content element on browsers that support native shadow
t=t.assignedSlot.parentNode.parentNode),t.parentNode!==this.$.items)return;if(e.stopPropagation(),this._toggleAttribute("dragging-rows",!0,this),this._safari){
// Safari doesn't get proper drag images from transformed
// elements so we need to switch to top temporarily
const e=t.style.transform;t.style.top=/translateY\((.*)\)/.exec(e)[1],t.style.transform="none",requestAnimationFrame(()=>{t.style.top="",t.style.transform=e})}const i=t.getBoundingClientRect();window.ShadyDOM||(this._ios?e.dataTransfer.setDragImage(t):e.dataTransfer.setDragImage(t,e.clientX-i.left,e.clientY-i.top));let s=[t];this._isSelected(t._item)&&(s=this.__getViewportRows().filter(e=>this._isSelected(e._item)).filter(e=>!this.dragFilter||this.dragFilter(this.__getRowModel(e)))),// Set the default transfer data
e.dataTransfer.setData("text",this.__formatDefaultTransferData(s)),t.setAttribute("dragstart",s.length>1?s.length:""),this.updateStyles({"--_grid-drag-start-x":e.clientX-i.left+20+"px","--_grid-drag-start-y":e.clientY-i.top+10+"px"}),requestAnimationFrame(()=>{t.removeAttribute("dragstart"),this.updateStyles({"--_grid-drag-start-x":"","--_grid-drag-start-y":""})});const r=new CustomEvent("grid-dragstart",{detail:{draggedItems:s.map(e=>e._item),setDragData:(t,i)=>e.dataTransfer.setData(t,i),setDraggedItemsCount:e=>t.setAttribute("dragstart",e)}});r.originalEvent=e,this.dispatchEvent(r)}}
/** @private */_onDragEnd(e){this._toggleAttribute("dragging-rows",!1,this),e.stopPropagation();const t=new CustomEvent("grid-dragend");t.originalEvent=e,this.dispatchEvent(t)}
/** @private */_onDragLeave(e){e.stopPropagation(),this._clearDragStyles()}
/** @private */_onDragOver(e){if(this.dropMode){if(this._dropLocation=void 0,this._dragOverItem=void 0,this.__dndAutoScroll(e.clientY))return void this._clearDragStyles();let t=e.composedPath().filter(e=>"tr"===e.localName)[0];if(this._effectiveSize&&this.dropMode!==n)if(t&&t.parentNode===this.$.items){
// The dragover occurred on a body row, determine the drop location from coordinates
const i=t.getBoundingClientRect();if(this._dropLocation=a,this.dropMode===s){const t=e.clientY-i.top<i.bottom-e.clientY;this._dropLocation=t?o:l}else this.dropMode===r&&(e.clientY-i.top<i.height/3?this._dropLocation=o:e.clientY-i.top>i.height/3*2&&(this._dropLocation=l))}else{
// The dragover didn't occur on a body row but the grid has items
if(t)
// The dragover occurred over a header/footer row
return;if(this.dropMode!==s&&this.dropMode!==r)
// Drop mode on-top used but the dragover didn't occur over one of the existing rows
return;
// The drop mode allows setting the last row as the drag over item
t=Array.from(this.$.items.children).filter(e=>!e.hidden).pop(),this._dropLocation=l}else
// The grid is empty or "on-grid" drop mode was used, always default to "empty"
this._dropLocation=h;if(t&&t.hasAttribute("drop-disabled"))return void(this._dropLocation=void 0);e.stopPropagation(),e.preventDefault(),this._dropLocation===h?this._toggleAttribute("dragover",!0,this):t?(this._dragOverItem=t._item,t.getAttribute("dragover")!==this._dropLocation&&t.setAttribute("dragover",this._dropLocation)):this._clearDragStyles()}}
/** @private */__dndAutoScroll(e){if(this.__dndAutoScrolling)return!0;const t=this.$.header.getBoundingClientRect().bottom,i=this.$.footer.getBoundingClientRect().top,s=t-e+this.__dndAutoScrollThreshold,r=e-i+this.__dndAutoScrollThreshold;let n=0;if(r>0?n=2*r:s>0&&(n=2*-s),n){const e=this.$.table.scrollTop;this.$.table.scrollTop+=n;if(e!==this.$.table.scrollTop)return this.__dndAutoScrolling=!0,// Disallow more auto-scrolls within 20ms
setTimeout(()=>this.__dndAutoScrolling=!1,20),this._scrollHandler(),!0}}
/** @private */__getViewportRows(){
// Workaround an IE11 bug where the `getBoundingClientRect` for header/footer
// might return incorrect values
this.$.header.style.outline="0px solid transparent";const e=this.$.scroller.getBoundingClientRect(),t=Math.max(this.$.header.getBoundingClientRect().bottom,e.top),i=Math.min(this.$.footer.getBoundingClientRect().top,e.bottom);return Array.from(this.$.items.children).filter(e=>{const s=e.getBoundingClientRect();return s.bottom>t&&s.top<i})}
/** @protected */_clearDragStyles(){this.removeAttribute("dragover"),Array.from(this.$.items.children).forEach(e=>e.removeAttribute("dragover"))}
/** @private */_onDrop(e){if(this.dropMode){e.stopPropagation(),e.preventDefault();const t=e.dataTransfer.types&&Array.from(e.dataTransfer.types).map(t=>({type:t,data:e.dataTransfer.getData(t)}));this._clearDragStyles();const i=new CustomEvent("grid-drop",{bubbles:e.bubbles,cancelable:e.cancelable,detail:{dropTargetItem:this._dragOverItem,dropLocation:this._dropLocation,dragData:t}});i.originalEvent=e,this.dispatchEvent(i)}}
/** @private */__formatDefaultTransferData(e){return e.map(e=>Array.from(e.children).filter(e=>!e.hidden&&-1===e.getAttribute("part").indexOf("details-cell")).sort((e,t)=>e._column._order>t._column._order?1:-1).map(e=>e._content.textContent.trim()).filter(e=>e).join("\t")).join("\n")}
/** @private */_dragDropAccessChanged(e,t,i,s){this.filterDragAndDrop()}
/**
   * Runs the `dragFilter` and `dropFilter` hooks for the visible cells.
   * If the filter depends on varying conditions, you may need to
   * call this function manually in order to update the draggability when
   * the conditions change.
   */filterDragAndDrop(){Array.from(this.$.items.children).filter(e=>!e.hidden).forEach(e=>{this._filterDragAndDrop(e,this.__getRowModel(e))})}
/**
   * @param {!HTMLElement} row
   * @param {!GridItemModel} model
   * @protected
   */_filterDragAndDrop(e,t){const i=this.loading||e.hasAttribute("loading"),s=!this.rowsDraggable||i||this.dragFilter&&!this.dragFilter(t),r=!this.dropMode||i||this.dropFilter&&!this.dropFilter(t);(window.ShadyDOM?[e]:Array.from(e.children).map(e=>e._content)).forEach(e=>{s?e.removeAttribute("draggable"):e.setAttribute("draggable",!0)}),this._toggleAttribute("drag-disabled",s,e),this._toggleAttribute("drop-disabled",r,e)}
/**
   * Fired when starting to drag grid rows.
   *
   * @event grid-dragstart
   * @param {Object} originalEvent The native dragstart event
   * @param {Object} detail
   * @param {Object} detail.draggedItems the items in the visible viewport that are dragged
   * @param {Function} detail.setDraggedItemsCount Overrides the default number shown in the drag image on multi row drag.
   * Parameter is of type number.
   * @param {Function} detail.setDragData Sets dataTransfer data for the drag operation.
   * Note that "text" is the only data type supported by all the browsers the grid currently supports (including IE11).
   * The function takes two parameters:
   * - type:string The type of the data
   * - data:string The data
   */
/**
   * Fired when the dragging of the rows ends.
   *
   * @event grid-dragend
   * @param {Object} originalEvent The native dragend event
   */
/**
   * Fired when a drop occurs on top of the grid.
   *
   * @event grid-drop
   * @param {Object} originalEvent The native drop event
   * @param {Object} detail
   * @param {Object} detail.dropTargetItem The item of the grid row on which the drop occurred.
   * @param {string} detail.dropLocation The position at which the drop event took place relative to a row.
   * Depending on the dropMode value, the drop location can be one of the following
   * - `on-top`: when the drop occurred on top of the row
   * - `above`: when the drop occurred above the row
   * - `below`: when the drop occurred below the row
   * - `empty`: when the drop occurred over the grid, not relative to any specific row
   * @param {string} detail.dragData An array of items with the payload as a string representation as the
   * `data` property and the type of the data as `type` property.
   */}
/***/},
/***/"8yxa":
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return n}));
/* harmony import */var s=i("Y40L"),r=i("F3iu");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const n=e=>class extends e{static get properties(){return{
/**
       * When `true`, all `<vaadin-grid-sorter>` are applied for sorting.
       * @attr {boolean} multi-sort
       * @type {boolean}
       */
multiSort:{type:Boolean,value:!1},
/**
       * @type {!Array<!GridSorter>}
       * @protected
       */
_sorters:{type:Array,value:function(){return[]}},
/** @private */
_previousSorters:{type:Array,value:function(){return[]}}}}
/** @protected */ready(){super.ready(),this.addEventListener("sorter-changed",this._onSorterChanged),// With Polymer 2 & shady the 'sorter-changed' listener isn't guaranteed to be registered
// before child <vaadin-grid-sorter>'s upgrade and fire the events. The following
// makes sure that 'sorter-changed' is fired for all <vaadin-grid-sorter> elements
// after this (<vaadin-grid>) is ready (and the listeners are active).
window.ShadyDOM&&s.c.run(()=>{const e=this.querySelectorAll("vaadin-grid-sorter");Array.from(e).forEach(e=>{
// Don't try to fire if the sorter hasn't been upgraded yet
e instanceof r.a&&e.dispatchEvent(new CustomEvent("sorter-changed",{bubbles:!0,composed:!0}))})})}
/** @private */_onSorterChanged(e){const t=e.target;e.stopPropagation(),this.__updateSorter(t),this.__applySorters()}
/** @private */__removeSorters(e){0!=e.length&&(this._sorters=this._sorters.filter(t=>e.indexOf(t)<0),this.multiSort&&this.__updateSortOrders(),this.__applySorters())}
/** @private */__updateSortOrders(){this._sorters.forEach((e,t)=>e._order=this._sorters.length>1?t:null,this)}
/** @private */__updateSorter(e){if(e.direction||-1!==this._sorters.indexOf(e))if(e._order=null,this.multiSort)this._removeArrayItem(this._sorters,e),e.direction&&this._sorters.unshift(e),this.__updateSortOrders(),this._sorters.forEach((e,t)=>e._order=this._sorters.length>1?t:null,this);else if(e.direction){const t=this._sorters.filter(t=>t!=e);this._sorters=[e],t.forEach(e=>{e._order=null,e.direction=null})}}
/** @private */__applySorters(){this.dataProvider&&// No need to clear cache if sorters didn't change and grid is attached
this.isAttached&&JSON.stringify(this._previousSorters)!==JSON.stringify(this._mapSorters())&&this.clearCache(),this._a11yUpdateSorters(),this._previousSorters=this._mapSorters()}
/**
   * @return {!Array<!GridSorter>}
   * @protected
   */_mapSorters(){return this._sorters.map(e=>({path:e.path,direction:e.direction}))}
/** @private */_removeArrayItem(e,t){const i=e.indexOf(t);i>-1&&e.splice(i,1)}}
/***/},
/***/D2N1:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return n}));
/* harmony import */var s=i("nduU"),r=i("hLn4");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const n=e=>class extends(Object(s.a)(e)){ready(){super.ready();const e=this.$.scroller;Object(r.a)(e,"track",this._onHeaderTrack.bind(this)),// Disallow scrolling while resizing
e.addEventListener("touchmove",t=>e.hasAttribute("column-resizing")&&t.preventDefault()),// Disable contextmenu on any resize separator.
e.addEventListener("contextmenu",e=>"resize-handle"==e.target.getAttribute("part")&&e.preventDefault()),// Disable native cell focus when resizing
e.addEventListener("mousedown",e=>"resize-handle"===e.target.getAttribute("part")&&e.preventDefault())}
/** @private */_onHeaderTrack(e){const t=e.target;if("resize-handle"===t.getAttribute("part")){let n=t.parentElement._column;// Get the target column to resize
for(this._toggleAttribute("column-resizing",!0,this.$.scroller);"vaadin-grid-column-group"===n.localName;)n=Array.prototype.slice.call(n._childColumns,0).sort((function(e,t){return e._order-t._order})).filter((function(e){return!e.hidden})).pop();const a=Array.from(this.$.header.querySelectorAll('[part~="row"]:last-child [part~="cell"]'));var i=a.filter(e=>e._column===n)[0];// Resize the target column
if(i.offsetWidth){var s=window.getComputedStyle(i),r=10+parseInt(s.paddingLeft)+parseInt(s.paddingRight)+parseInt(s.borderLeftWidth)+parseInt(s.borderRightWidth)+parseInt(s.marginLeft)+parseInt(s.marginRight);const t=i.offsetWidth+(this.__isRTL?i.getBoundingClientRect().left-e.detail.x:e.detail.x-i.getBoundingClientRect().right);n.width=Math.max(r,t)+"px",n.flexGrow=0}// Fix width and flex-grow for all preceding columns
a.sort((function(e,t){return e._column._order-t._column._order})).forEach((function(e,t,s){t<s.indexOf(i)&&(e._column.width=e.offsetWidth+"px",e._column.flexGrow=0)})),"end"===e.detail.state&&(this._toggleAttribute("column-resizing",!1,this.$.scroller),this.dispatchEvent(new CustomEvent("column-resize",{detail:{resizedColumn:n}}))),// Notify resize
this._resizeHandler()}}
/**
  * Fired when a column in the grid is resized by the user.
  *
  * @event column-resize
  * @param {Object} detail
  * @param {Object} detail.resizedColumn the column that was resized
  */}
/***/},
/***/E5z9:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return s}));
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const s=e=>class extends e{static get properties(){return{
/**
       * An array that contains the selected items.
       * @type {Array<GridItem>}
       */
selectedItems:{type:Object,notify:!0,value:()=>[]}}}static get observers(){return["_selectedItemsChanged(selectedItems.*)"]}
/**
   * @param {!GridItem} item
   * @return {boolean}
   * @protected
   */_isSelected(e){return this.selectedItems&&this._getItemIndexInArray(e,this.selectedItems)>-1}
/**
   * Selects the given item.
   *
   * @method selectItem
   * @param {!GridItem} item The item object
   */selectItem(e){this._isSelected(e)||this.push("selectedItems",e)}
/**
   * Deselects the given item if it is already selected.
   *
   * @method deselect
   * @param {!GridItem} item The item object
   */deselectItem(e){const t=this._getItemIndexInArray(e,this.selectedItems);t>-1&&this.splice("selectedItems",t,1)}
/**
   * Toggles the selected state of the given item.
   *
   * @method toggle
   * @param {!GridItem} item The item object
   * @protected
   */_toggleItem(e){-1===this._getItemIndexInArray(e,this.selectedItems)?this.selectItem(e):this.deselectItem(e)}
/** @private */_selectedItemsChanged(e){this._assignModels()}
/** @private */_selectedInstanceChangedCallback(e,t){super._selectedInstanceChangedCallback&&super._selectedInstanceChangedCallback(e,t),t?this.selectItem(e.item):this.deselectItem(e.item)}}
/***/},
/***/Hcmf:
/***/function(e,t,i){"use strict";
/* harmony import */i("O5q1");
/* harmony import */var s=i("o5Wi");
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
const r=document.createElement("dom-module");// NOTE(web-padawan): https://github.com/vaadin/vaadin-grid/issues/1514
r.appendChild(s.a`<style>@keyframes vaadin-grid-appear{to{opacity:1}}:host{display:block;animation:1ms vaadin-grid-appear;height:400px;flex:1 1 auto;align-self:stretch;position:relative}:host([hidden]){display:none!important}#scroller{display:block;transform:translateY(0);width:auto;height:auto;position:absolute;top:0;right:0;bottom:0;left:0}:host([all-rows-visible]),:host([height-by-rows]){height:auto;align-self:flex-start;flex-grow:0;width:100%}:host([all-rows-visible]) #scroller,:host([height-by-rows]) #scroller{width:100%;height:100%;position:relative}#table{display:flex;flex-direction:column;width:100%;height:100%;overflow:auto;position:relative;outline:0;z-index:0}#footer,#header{display:block;position:-webkit-sticky;position:sticky;left:0;overflow:visible;width:100%;z-index:1}#header{top:0}th{text-align:inherit}[safari] th{text-align:initial}#footer{bottom:0}#items{flex-grow:1;flex-shrink:0;display:block;position:-webkit-sticky;position:sticky;width:100%;left:0;overflow:visible}[part~=row]{display:flex;width:100%;box-sizing:border-box;margin:0}[part~=row][loading] [part~=body-cell] ::slotted(vaadin-grid-cell-content){opacity:0}#items [part~=row]{position:absolute}#items [part~=row]:empty{height:1em}[part~=cell]:not([part~=details-cell]){flex-shrink:0;flex-grow:1;box-sizing:border-box;display:flex;width:100%;position:relative;align-items:center;padding:0;white-space:nowrap}[part~=details-cell]{position:absolute;bottom:0;width:100%;box-sizing:border-box;padding:0}[part~=cell] ::slotted(vaadin-grid-cell-content){display:block;width:100%;box-sizing:border-box;overflow:hidden;text-overflow:ellipsis}[hidden]{display:none!important}[frozen]{z-index:2;will-change:transform}[no-scrollbars][firefox] #table,[no-scrollbars][safari] #table{overflow:hidden}#scroller[no-content-pointer-events] [part~=cell] ::slotted(vaadin-grid-cell-content),:host([reordering]) [part~=cell] ::slotted(vaadin-grid-cell-content),:host([reordering]) [part~=resize-handle]{pointer-events:none}[part~=reorder-ghost]{visibility:hidden;position:fixed;pointer-events:none;opacity:.5;top:0;left:0}:host([reordering]){-moz-user-select:none;-webkit-user-select:none;user-select:none}#scroller[ie][column-reordering-allowed] [part~=header-cell]{-ms-user-select:none}[part~=resize-handle]{position:absolute;top:0;right:0;height:100%;cursor:col-resize;z-index:1}[part~=resize-handle]::before{position:absolute;content:"";height:100%;width:35px;transform:translateX(-50%)}[last-column] [part~=resize-handle]::before,[last-frozen] [part~=resize-handle]::before{width:18px;transform:none;right:0}#scroller[column-resizing]{-ms-user-select:none;-moz-user-select:none;-webkit-user-select:none;user-select:none}#sizer{display:flex;position:absolute;visibility:hidden}#sizer [part~=details-cell]{display:none!important}#sizer [part~=cell][hidden]{display:none!important}#sizer [part~=cell]{display:block;flex-shrink:0;line-height:0;height:0!important;min-height:0!important;max-height:0!important;padding:0!important;border:none!important}#sizer [part~=cell]::before{content:"-"}#sizer [part~=cell] ::slotted(vaadin-grid-cell-content){display:none!important}:host([dir=rtl]) #footer,:host([dir=rtl]) #header,:host([dir=rtl]) #items{left:auto}:host([dir=rtl]) [part~=reorder-ghost]{left:auto;right:0}:host([dir=rtl]) [part~=resize-handle]{left:0;right:auto}:host([dir=rtl]) [part~=resize-handle]::before{transform:translateX(50%)}:host([dir=rtl]) [last-column] [part~=resize-handle]::before,:host([dir=rtl]) [last-frozen] [part~=resize-handle]::before{left:0;right:auto}</style>`),r.register("vaadin-grid-styles")},
/***/KVNo:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return s}));
/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const s=e=>class extends e{
/**
   * Returns an object with context information about the event target:
   * - `item`: the data object corresponding to the targeted row (not specified when targeting header or footer)
   * - `column`: the column element corresponding to the targeted cell (not specified when targeting row details)
   * - `section`: whether the event targeted the body, header, footer or details of the grid
   *
   * These additional properties are included when `item` is specified:
   * - `index`: the index of the item
   * - `selected`: the selected state of the item
   * - `detailsOpened`: whether the row details are open for the item
   * - `expanded`: the expanded state of the tree toggle
   * - `level`: the tree hierarchy level
   *
   * The returned object is populated only when a grid cell, header, footer or row details is found in `event.composedPath()`.
   * This means mostly mouse and keyboard events. If such a grid part is not found in the path, an empty object is returned.
   * This may be the case eg. if the event is fired on the `<vaadin-grid>` element and not any deeper in the DOM, or if
   * the event targets the empty part of the grid body.
   *
   * @param {!Event} event
   * @return {GridEventContext | object}
   */
getEventContext(e){const t={},i=e.composedPath(),s=i[i.indexOf(this.$.table)-3];return s?(t.section=["body","header","footer","details"].filter(e=>s.getAttribute("part").indexOf(e)>-1)[0],s._column&&(t.column=s._column),"body"!==t.section&&"details"!==t.section||Object.assign(t,this.__getRowModel(s.parentElement)),t):t}}
/***/},
/***/LVTK:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return s}));
/* unused harmony export isFocusable */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const s=e=>class extends e{static get properties(){return{
/**
       * The item user has last interacted with. Turns to `null` after user deactivates
       * the item by re-interacting with the currently active item.
       * @type {GridItem}
       */
activeItem:{type:Object,notify:!0,value:null}}}ready(){super.ready(),this.$.scroller.addEventListener("click",this._onClick.bind(this)),this.addEventListener("cell-activate",this._activateItem.bind(this))}
/** @private */_activateItem(e){const t=e.detail.model,i=t?t.item:null;i&&(this.activeItem=this._itemsEqual(this.activeItem,i)?null:i)}
/**
   * We need to listen to click instead of tap because on mobile safari, the
   * document.activeElement has not been updated (focus has not been shifted)
   * yet at the point when tap event is being executed.
   * @param {!MouseEvent} e
   * @protected
   */_onClick(e){if(e.defaultPrevented)
// Something has handled this click already, e. g., <vaadin-grid-sorter>
return;const t=e.composedPath(),i=t[t.indexOf(this.$.table)-3];if(!i||i.getAttribute("part").indexOf("details-cell")>-1)return;const s=i._content,r=this.getRootNode().activeElement;s.contains(r)&&(// MSIE bug: flex children receive focus. Make type & attributes check.
!this._ie||this._isFocusable(r))||this._isFocusable(e.target)||this.dispatchEvent(new CustomEvent("cell-activate",{detail:{model:this.__getRowModel(i.parentElement)}}))}
/**
   * @param {!Element} target
   * @return {boolean}
   * @protected
   */_isFocusable(e){return r(e)}}
/**
 * @param {!Element} target
 * @return {boolean}
 * @protected
 */,r=e=>{if(!e.parentNode)return!1;const t=-1!==Array.from(e.parentNode.querySelectorAll("[tabindex], button, input, select, textarea, object, iframe, label, a[href], area[href]")).filter(e=>"cell body-cell"!==e.getAttribute("part")).indexOf(e);return!e.disabled&&t}},
/***/QSr5:
/***/function(e,t,i){"use strict";
/* unused harmony export GridSelectionColumnElement */
/* harmony import */i("pYlh");
/* harmony import */var s=i("qu6e"),r=(i("lFcJ"),i("o5Wi"));
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-grid-selection-column>` is a helper element for the `<vaadin-grid>`
 * that provides default templates and functionality for item selection.
 *
 * #### Example:
 * ```html
 * <vaadin-grid items="[[items]]">
 *  <vaadin-grid-selection-column frozen auto-select></vaadin-grid-selection-column>
 *
 *  <vaadin-grid-column>
 *    ...
 * ```
 *
 * By default the selection column displays `<vaadin-checkbox>` elements in the
 * column cells. The checkboxes in the body rows toggle selection of the corresponding row items.
 *
 * When the grid data is provided as an array of [`items`](#/elements/vaadin-grid#property-items),
 * the column header gets an additional checkbox that can be used for toggling
 * selection for all the items at once.
 *
 * __The default content can also be overridden__
 *
 */
class n extends s.a{static get template(){return r.a`<template class="header" id="defaultHeaderTemplate"><vaadin-checkbox class="vaadin-grid-select-all-checkbox" aria-label="Select All" hidden\$="[[_selectAllHidden]]" on-checked-changed="_onSelectAllCheckedChanged" checked="[[_isChecked(selectAll, _indeterminate)]]" indeterminate="[[_indeterminate]]"></vaadin-checkbox></template><template id="defaultBodyTemplate"><vaadin-checkbox aria-label="Select Row" checked="{{selected}}"></vaadin-checkbox></template>`}static get is(){return"vaadin-grid-selection-column"}static get properties(){return{
/**
       * Width of the cells for this column.
       */
width:{type:String,value:"58px"},
/**
       * Flex grow ratio for the cell widths. When set to 0, cell width is fixed.
       * @attr {number} flex-grow
       * @type {number}
       */
flexGrow:{type:Number,value:0},
/**
       * When true, all the items are selected.
       * @attr {boolean} select-all
       * @type {boolean}
       */
selectAll:{type:Boolean,value:!1,notify:!0},
/**
       * When true, the active gets automatically selected.
       * @attr {boolean} auto-select
       * @type {boolean}
       */
autoSelect:{type:Boolean,value:!1},
/** @private */
_indeterminate:Boolean,
/**
       * The previous state of activeItem. When activeItem turns to `null`,
       * previousActiveItem will have an Object with just unselected activeItem
       * @private
       */
_previousActiveItem:Object,
/** @private */
_selectAllHidden:Boolean}}static get observers(){return["_onSelectAllChanged(selectAll)"]}
/** @private */_pathOrHeaderChanged(e,t,i,s,r,n,a,o,l){
// As a special case, allow overriding the default header / body templates
!r.value||void 0===e&&void 0===n||(this._bodyTemplate=o=void 0,this.__cleanCellsOfTemplateProperties(r.value)),!i||void 0===t&&void 0===a||(this._headerTemplate=l=void 0,this.__cleanCellsOfTemplateProperties([i])),super._pathOrHeaderChanged(e,t,i,s,r,n,a,o,l)}
/** @private */__cleanCellsOfTemplateProperties(e){e.forEach(e=>{e._content.innerHTML="",delete e._instance,delete e._template})}
/** @private */_prepareHeaderTemplate(){const e=this._prepareTemplatizer(this._findTemplate(!0)||this.$.defaultHeaderTemplate);// needed to override the dataHost correctly in case internal template is used.
return e.templatizer.dataHost=e===this.$.defaultHeaderTemplate?this:this.dataHost,e}
/** @private */_prepareBodyTemplate(){const e=this._prepareTemplatizer(this._findTemplate()||this.$.defaultBodyTemplate);// needed to override the dataHost correctly in case internal template is used.
return e.templatizer.dataHost=e===this.$.defaultBodyTemplate?this:this.dataHost,e}constructor(){super(),this._boundOnActiveItemChanged=this._onActiveItemChanged.bind(this),this._boundOnDataProviderChanged=this._onDataProviderChanged.bind(this),this._boundOnSelectedItemsChanged=this._onSelectedItemsChanged.bind(this)}
/** @protected */disconnectedCallback(){this._grid.removeEventListener("active-item-changed",this._boundOnActiveItemChanged),this._grid.removeEventListener("data-provider-changed",this._boundOnDataProviderChanged),this._grid.removeEventListener("filter-changed",this._boundOnSelectedItemsChanged),this._grid.removeEventListener("selected-items-changed",this._boundOnSelectedItemsChanged);if(/^((?!chrome|android).)*safari/i.test(navigator.userAgent)&&window.ShadyDOM&&this.parentElement){
// Detach might have beem caused by order change.
// Shady on safari doesn't restore isAttached so we'll need to do it manually.
const e=this.parentElement,t=this.nextElementSibling;e.removeChild(this),t?e.insertBefore(this,t):e.appendChild(this)}super.disconnectedCallback()}
/** @protected */connectedCallback(){super.connectedCallback(),this._grid&&(this._grid.addEventListener("active-item-changed",this._boundOnActiveItemChanged),this._grid.addEventListener("data-provider-changed",this._boundOnDataProviderChanged),this._grid.addEventListener("filter-changed",this._boundOnSelectedItemsChanged),this._grid.addEventListener("selected-items-changed",this._boundOnSelectedItemsChanged))}
/** @private */_onSelectAllChanged(e){void 0!==e&&this._grid&&(this._selectAllChangeLock||(this._grid.selectedItems=e&&Array.isArray(this._grid.items)?this._grid._filter(this._grid.items):[]))}
/**
   * Return true if array `a` contains all the items in `b`
   * We need this when sorting or to preserve selection after filtering.
   * @private
   */_arrayContains(e,t){for(var i=0;e&&t&&t[i]&&e.indexOf(t[i])>=0;i++);// eslint-disable-line
return i==t.length}
/** @private */_onSelectAllCheckedChanged(e){this.selectAll=this._indeterminate||e.target.checked}
/**
   * iOS needs indeterminated + checked at the same time
   * @private
   */_isChecked(e,t){return t||e}
/** @private */_onActiveItemChanged(e){const t=e.detail.value;if(this.autoSelect){const e=t||this._previousActiveItem;e&&this._grid._toggleItem(e)}this._previousActiveItem=t}
/** @private */_onSelectedItemsChanged(e){this._selectAllChangeLock=!0,Array.isArray(this._grid.items)&&(this._grid.selectedItems.length?this._arrayContains(this._grid.selectedItems,this._grid._filter(this._grid.items))?(this.selectAll=!0,this._indeterminate=!1):(this.selectAll=!1,this._indeterminate=!0):(this.selectAll=!1,this._indeterminate=!1)),this._selectAllChangeLock=!1}
/** @private */_onDataProviderChanged(e){this._selectAllHidden=!Array.isArray(this._grid.items)}}customElements.define(n.is,n)},
/***/SnEI:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return s}));
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const s=e=>class extends e{static get properties(){return{
/** @private */
_headerFocusable:{type:Object,observer:"_focusableChanged"},
/**
       * @type {!HTMLElement | undefined}
       * @protected
       */
_itemsFocusable:{type:Object,observer:"_focusableChanged"},
/** @private */
_footerFocusable:{type:Object,observer:"_focusableChanged"},
/** @private */
_navigatingIsHidden:Boolean,
/**
       * @type {number}
       * @protected
       */
_focusedItemIndex:{type:Number,value:0},
/** @private */
_focusedColumnOrder:Number,
/**
       * Indicates whether the grid is currently in interaction mode.
       * In interaction mode the user is currently interacting with a control,
       * such as an input or a select, within a cell.
       * In interaction mode keyboard navigation between cells is disabled.
       * Interaction mode also prevents the focus target cell of that section of
       * the grid from receiving focus, allowing the user to switch focus to
       * controls in adjacent cells, rather than focussing the outer cell
       * itself.
       * @type {boolean}
       * @private
       */
interacting:{type:Boolean,value:!1,reflectToAttribute:!0,readOnly:!0,observer:"_interactingChanged"}}}
/** @protected */ready(){super.ready(),this._ios||this._android||(this.addEventListener("keydown",this._onKeyDown),this.addEventListener("keyup",this._onKeyUp),this.addEventListener("focusin",this._onFocusIn),this.addEventListener("focusout",this._onFocusOut),// When focus goes from cell to another cell, focusin/focusout events do
// not escape the grid’s shadowRoot, thus listening inside the shadowRoot.
this.$.table.addEventListener("focusin",this._onCellFocusIn.bind(this)),this.$.table.addEventListener("focusout",this._onCellFocusOut.bind(this)),this.addEventListener("mousedown",()=>{this._toggleAttribute("navigating",!1,this),this._isMousedown=!0}),this.addEventListener("mouseup",()=>this._isMousedown=!1))}
/** @private */_focusableChanged(e,t){t&&t.setAttribute("tabindex","-1"),e&&this._updateGridSectionFocusTarget(e)}
/** @private */_interactingChanged(){
// Update focus targets when entering / exiting interaction mode
this._updateGridSectionFocusTarget(this._headerFocusable),this._updateGridSectionFocusTarget(this._itemsFocusable),this._updateGridSectionFocusTarget(this._footerFocusable)}
/**
   * @param {!KeyboardEvent} e
   * @protected
   */_onKeyDown(e){
// Ensure standard key value, unified across browsers
let t,i=e.key;switch("Up"!==i&&"Down"!==i&&"Left"!==i&&"Right"!==i||(
// MSIE & Edge
i="Arrow"+i),"Esc"===i&&(
// MSIE & Edge
i="Escape"),"Spacebar"===i&&(
// MSIE
i=" "),i){case"ArrowUp":case"ArrowDown":case"ArrowLeft":case"ArrowRight":case"PageUp":case"PageDown":case"Home":case"End":t="Navigation";break;case"Enter":case"Escape":case"F2":t="Interaction";break;case"Tab":t="Tab";break;case" ":t="Space"}this._detectInteracting(e),this.interacting&&"Interaction"!==t&&(
// When in the interacting mode, only the “Interaction” keys are handled.
t=void 0),t&&this[`_on${t}KeyDown`](e,i)}
/** @private */_ensureScrolledToIndex(e){Array.from(this.$.items.children).filter(t=>t.index===e)[0]||this._scrollToIndex(e)}
/** @private */_onNavigationKeyDown(e,t){function i(e){return Array.prototype.indexOf.call(e.parentNode.children,e)}this._scrollHandler(),e.preventDefault();const s=this._lastVisibleIndex-this._firstVisibleIndex-1;let r=0,n=0;switch(t){case"ArrowRight":r=this.__isRTL?-1:1;break;case"ArrowLeft":r=this.__isRTL?1:-1;break;case"Home":r=-1/0,e.ctrlKey&&(n=-1/0);break;case"End":r=1/0,e.ctrlKey&&(n=1/0);break;case"ArrowDown":n=1;break;case"ArrowUp":n=-1;break;case"PageDown":n=s;break;case"PageUp":n=-s}const a=e.composedPath()[0],o=i(a),l=this._elementMatches(a,'[part~="details-cell"]'),h=a.parentNode,d=h.parentNode,c=(d===this.$.items?this._effectiveSize:d.children.length)-1,_=d===this.$.items?void 0!==this._focusedItemIndex?this._focusedItemIndex:h.index:i(h);// Index of the destination row
let u=Math.max(0,Math.min(_+n,c)),p=!1;// Row details navigation logic
if(d===this.$.items){const e=h._item,t=this._cache.getItemForIndex(u);// Should we navigate to row details?
p=l?0===n:1===n&&this._isDetailsOpened(e)||-1===n&&u!==_&&this._isDetailsOpened(t),// Should we navigate between details and regular cells of the same row?
p!==l&&(1===n&&p||-1===n&&!p)&&(u=_)}// Header and footer could have hidden rows, e. g., if none of the columns
// or groups on the given column tree level define template. Skip them
// in vertical keyboard navigation.
if(d!==this.$.items)if(u>_)for(;u<c&&d.children[u].hidden;)u++;else if(u<_)for(;u>0&&d.children[u].hidden;)u--;// _focusedColumnOrder is memoized — this is to ensure predictable
// navigation when entering and leaving detail and column group cells.
void 0===this._focusedColumnOrder&&(this._focusedColumnOrder=l?0:this._getColumns(d,_).filter(e=>!e.hidden)[o]._order);// Find orderedColumnIndex — the index of order closest matching the
// original _focusedColumnOrder in the sorted array of orders
// of the visible columns on the destination row.
const g=this._getColumns(d,u).filter(e=>!e.hidden),m=g.map(e=>e._order).sort((e,t)=>e-t),f=m.length-1,b=m.indexOf(m.slice(0).sort((e,t)=>Math.abs(e-this._focusedColumnOrder)-Math.abs(t-this._focusedColumnOrder))[0]),v=0===n&&l?b:Math.max(0,Math.min(b+r,f));v!==b&&(
// Horizontal movement invalidates stored _focusedColumnOrder
this._focusedColumnOrder=void 0),// Ensure correct vertical scroll position, destination row is visible
d===this.$.items&&this._ensureScrolledToIndex(u),// This has to be set after scrolling, otherwise it can be removed by
// `_preventScrollerRotatingCellFocus(row, index)` during scrolling.
this._toggleAttribute("navigating",!0,this);const A=g.reduce((e,t,i)=>(e[t._order]=i,e),{})[m[v]],y=d===this.$.items?Array.from(d.children).filter(e=>e.index===u)[0]:d.children[u];if(!y)return;// Here we go!
const C=p?Array.from(y.children).filter(e=>this._elementMatches(e,'[part~="details-cell"]'))[0]:y.children[A];if(this._scrollHorizontallyToCell(C),d===this.$.items&&(
// When scrolling with repeated keydown, sometimes FocusEvent listeners
// are too late to update _focusedItemIndex. Ensure next keydown
// listener invocation gets updated _focusedItemIndex value.
this._focusedItemIndex=u),d===this.$.items){const e=C.getBoundingClientRect(),t=this.$.footer.getBoundingClientRect().top,i=this.$.header.getBoundingClientRect().bottom;e.bottom>t?(this.$.table.scrollTop+=e.bottom-t,this._scrollHandler()):e.top<i&&(this.$.table.scrollTop-=i-e.top,this._scrollHandler())}C.focus()}
/** @private */_onInteractionKeyDown(e,t){const i=e.composedPath()[0],s="input"===i.localName&&!/^(button|checkbox|color|file|image|radio|range|reset|submit)$/i.test(i.type);let r;switch(t){case"Enter":r=!this.interacting||!s;break;case"Escape":r=!1;break;case"F2":r=!this.interacting}const{cell:n}=this._getGridEventLocation(e);if(this.interacting!==r&&null!==n)if(r){const t=n._content.querySelector("[focus-target]")||n._content.firstElementChild;t&&(e.preventDefault(),t.focus(),this._setInteracting(!0),this._toggleAttribute("navigating",!1,this))}else e.preventDefault(),this._focusedColumnOrder=void 0,n.focus(),this._setInteracting(!1),this._toggleAttribute("navigating",!0,this)}
/** @private */_predictFocusStepTarget(e,t){const i=[this.$.table,this._headerFocusable,this._itemsFocusable,this._footerFocusable,this.$.focusexit];let s=i.indexOf(e);for(s+=t;s>=0&&s<=i.length-1&&(!i[s]||i[s].parentNode.hidden);)s+=t;return i[s]}
/** @private */_onTabKeyDown(e){const t=this._predictFocusStepTarget(e.composedPath()[0],e.shiftKey?-1:1);if(t===this.$.table)
// The focus is about to exit the grid to the top.
this.$.table.focus();else if(t===this.$.focusexit)
// The focus is about to exit the grid to the bottom.
this.$.focusexit.focus();else if(t===this._itemsFocusable){let i=t;const s=this._itemsFocusable.parentNode;if(this._ensureScrolledToIndex(this._focusedItemIndex),s.index!==this._focusedItemIndex){
// The target row, which is about to be focused next, has been
// assigned with a new index since last focus, probably because of
// scrolling. Focus the row for the stored focused item index instead.
const e=Array.from(s.children).indexOf(this._itemsFocusable),t=Array.from(this.$.items.children).filter(e=>e.index===this._focusedItemIndex)[0];t&&(i=t.children[e])}e.preventDefault(),i.focus()}else e.preventDefault(),t.focus();this._toggleAttribute("navigating",!0,this)}
/** @private */_onSpaceKeyDown(e){e.preventDefault();const t=e.composedPath()[0];t._content&&t._content.firstElementChild||this.dispatchEvent(new CustomEvent("cell-activate",{detail:{model:this.__getRowModel(t.parentElement)}}))}
/** @private */_onKeyUp(e){if(!/^( |SpaceBar)$/.test(e.key))return;e.preventDefault();const t=e.composedPath()[0];if(t._content&&t._content.firstElementChild){const e=this.hasAttribute("navigating");t._content.firstElementChild.click(),this._toggleAttribute("navigating",e,this)}}
/**
   * @param {!FocusEvent} e
   * @protected
   */_onFocusIn(e){this._isMousedown||this._toggleAttribute("navigating",!0,this);const t=e.composedPath()[0];t===this.$.table||t===this.$.focusexit?(
// The focus enters the top (bottom) of the grid, meaning that user has
// tabbed (shift-tabbed) into the grid. Move the focus to
// the first (the last) focusable.
this._predictFocusStepTarget(t,t===this.$.table?1:-1).focus(),this._setInteracting(!1)):this._detectInteracting(e)}
/**
   * @param {!FocusEvent} e
   * @protected
   */_onFocusOut(e){this._toggleAttribute("navigating",!1,this),this._detectInteracting(e)}
/** @private */_onCellFocusIn(e){const{section:t,cell:i}=this._getGridEventLocation(e);if(this._detectInteracting(e),t&&i){this._activeRowGroup=t,this.$.header===t?this._headerFocusable=i:this.$.items===t?this._itemsFocusable=i:this.$.footer===t&&(this._footerFocusable=i),// Inform cell content of the focus (used in <vaadin-grid-sorter>)
i._content.dispatchEvent(new CustomEvent("cell-focusin",{bubbles:!1}));// Fire a public event for cell focus.
const s=this.getEventContext(e);i.dispatchEvent(new CustomEvent("cell-focus",{bubbles:!0,composed:!0,detail:{context:s}}))}this._detectFocusedItemIndex(e)}
/** @private */_onCellFocusOut(e){if(3===e.composedPath().indexOf(this.$.table)){// Inform cell content of the focus (used in <vaadin-grid-sorter>)
e.composedPath()[0]._content.dispatchEvent(new CustomEvent("cell-focusout",{bubbles:!1}))}}
/** @private
   * Enables interaction mode if a cells descendant receives focus or keyboard
   * input. Disables it if the event is not related to cell content.
   * @param {!KeyboardEvent|!FocusEvent} e
   */_detectInteracting(e){const t=e.composedPath().some(e=>"vaadin-grid-cell-content"===e.localName);this._setInteracting(t)}
/** @private */_detectFocusedItemIndex(e){const{section:t,row:i}=this._getGridEventLocation(e);t===this.$.items&&(this._focusedItemIndex=i.index)}
/** @private
   * Enables or disables the focus target cell of the containing section of the
   * grid from receiving focus, based on whether the user is interacting with
   * that section of the grid.
   * @param {HTMLTableCellElement} focusTargetCell
   */_updateGridSectionFocusTarget(e){if(!e)return;const t=this._getGridSectionFromFocusTarget(e),i=this.interacting&&t===this._activeRowGroup;e.tabIndex=i?-1:0}
/**
   * @param {!HTMLTableRowElement} row
   * @param {number} index
   * @protected
   */_preventScrollerRotatingCellFocus(e,t){e.index===this._focusedItemIndex&&this.hasAttribute("navigating")&&this._activeRowGroup===this.$.items&&(
// Focused item has went, hide navigation mode
this._navigatingIsHidden=!0,this._toggleAttribute("navigating",!1,this)),t===this._focusedItemIndex&&this._navigatingIsHidden&&(
// Focused item is back, restore navigation mode
this._navigatingIsHidden=!1,this._toggleAttribute("navigating",!0,this))}
/**
   * @param {HTMLTableSectionElement=} rowGroup
   * @param {number=} rowIndex
   * @return {!Array<!GridColumnElement>}
   * @protected
   */_getColumns(e,t){let i=this._columnTree.length-1;return e===this.$.header?i=t:e===this.$.footer&&(i=this._columnTree.length-1-t),this._columnTree[i]}
/** @protected */_resetKeyboardNavigation(){if(this.$.header.firstElementChild&&(this._headerFocusable=Array.from(this.$.header.firstElementChild.children).filter(e=>!e.hidden)[0]),this.$.items.firstElementChild){const e=this._iterateItems((e,t)=>{if(this._firstVisibleIndex===t)return this.$.items.children[e]});e&&(this._itemsFocusable=Array.from(e.children).filter(e=>!e.hidden)[0])}this.$.footer.firstElementChild&&(this._footerFocusable=Array.from(this.$.footer.firstElementChild.children).filter(e=>!e.hidden)[0])}
/**
   * @param {!HTMLElement} dstCell
   * @protected
   */_scrollHorizontallyToCell(e){if(e.hasAttribute("frozen")||this._elementMatches(e,'[part~="details-cell"]'))
// These cells are, by design, always visible, no need to scroll.
return;const t=e.getBoundingClientRect(),i=e.parentNode,s=Array.from(i.children).indexOf(e),r=this.$.table.getBoundingClientRect();let n=r.left,a=r.right;for(let e=s-1;e>=0;e--){const t=i.children[e];if(!t.hasAttribute("hidden")&&!this._elementMatches(t,'[part~="details-cell"]')&&t.hasAttribute("frozen")){n=t.getBoundingClientRect().right;break}}for(let e=s+1;e<i.children.length;e++){const t=i.children[e];if(!t.hasAttribute("hidden")&&!this._elementMatches(t,'[part~="details-cell"]')&&t.hasAttribute("frozen")){a=t.getBoundingClientRect().left;break}}t.left<n&&(this.$.table.scrollLeft+=Math.round(t.left-n)),t.right>a&&(this.$.table.scrollLeft+=Math.round(t.right-a))}
/** @private */_elementMatches(e,t){return e.matches?e.matches(t):-1!==Array.from(e.parentNode.querySelectorAll(t)).indexOf(e)}
/**
   * @typedef {Object} GridEventLocation
   * @property {HTMLTableSectionElement | null} section - The table section element that the event occurred in (header, body, or footer),
   * or null if the event did not occur in a section
   * @property {HTMLTableRowElement | null} row - The row element that the event occurred in, or null if the event did not occur in a row
   * @property {HTMLTableCellElement | null} cell - The cell element that the event occurred in, or null if the event did not occur in a
   * cell
   * @private
   */
/**
   * Takes an event and returns a location object describing in which part of the grid the event occurred.
   * The event may either target table section, a row, a cell or contents of a cell.
   * @param {Event} e
   * @returns {GridEventLocation}
   * @private
   */_getGridEventLocation(e){const t=e.composedPath(),i=t.indexOf(this.$.table);return{section:i>=1?t[i-1]:null,row:i>=2?t[i-2]:null,cell:i>=3?t[i-3]:null}}
/**
   * Helper method that maps a focus target cell to the containing grid section
   * @param {HTMLTableCellElement} focusTargetCell
   * @returns {HTMLTableSectionElement | null}
   * @private
   */_getGridSectionFromFocusTarget(e){return e===this._headerFocusable?this.$.header:e===this._itemsFocusable?this.$.items:e===this._footerFocusable?this.$.footer:null}
/**
   * Fired when a cell is focused with click or keyboard navigation.
   *
   * Use context property of @see {@link GridCellFocusEvent} to get detail information about the event.
   *
   * @event cell-focus
   */}
/***/},
/***/VpZK:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return s}));
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const s=e=>class extends e{static get properties(){return{
/** @private */
_filters:{type:Array,value:function(){return[]}}}}
/** @protected */ready(){super.ready(),this.addEventListener("filter-changed",this._filterChanged.bind(this))}
/** @private */_filterChanged(e){e.stopPropagation(),this.__addFilter(e.target),this.__applyFilters()}
/** @private */__removeFilters(e){0!=e.length&&(this._filters=this._filters.filter(t=>e.indexOf(t)<0),this.__applyFilters())}
/** @private */__addFilter(e){-1===this._filters.indexOf(e)&&this._filters.push(e)}
/** @private */__applyFilters(){this.dataProvider&&this.isAttached&&this.clearCache()}
/**
   * @return {!Array<!GridFilter>}
   * @protected
   */_mapFilters(){return this._filters.map(e=>({path:e.path,value:e.value}))}}
/***/},
/***/X2En:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return s}));
/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const s=e=>class extends e{static get properties(){return{
/**
       * A function that allows generating CSS class names for grid cells
       * based on their row and column. The return value should be the generated
       * class name as a string, or multiple class names separated by whitespace
       * characters.
       *
       * Receives two arguments:
       * - `column` The `<vaadin-grid-column>` element (`undefined` for details-cell).
       * - `model` The object with the properties related with
       *   the rendered item, contains:
       *   - `model.index` The index of the item.
       *   - `model.item` The item.
       *   - `model.expanded` Sublevel toggle state.
       *   - `model.level` Level of the tree represented with a horizontal offset of the toggle button.
       *   - `model.selected` Selected state.
       *
       * @type {GridCellClassNameGenerator | null | undefined}
       */
cellClassNameGenerator:Function}}static get observers(){return["__cellClassNameGeneratorChanged(cellClassNameGenerator)"]}__cellClassNameGeneratorChanged(e){this.generateCellClassNames()}
/**
   * Runs the `cellClassNameGenerator` for the visible cells.
   * If the generator depends on varying conditions, you need to
   * call this function manually in order to update the styles when
   * the conditions change.
   */generateCellClassNames(){Array.from(this.$.items.children).filter(e=>!e.hidden).forEach(e=>this._generateCellClassNames(e,this.__getRowModel(e)))}
/** @private */_generateCellClassNames(e,t){Array.from(e.children).forEach(e=>{if(e.__generatedClasses&&e.__generatedClasses.forEach(t=>e.classList.remove(t)),this.cellClassNameGenerator){const i=this.cellClassNameGenerator(e._column,t);e.__generatedClasses=i&&i.split(" ").filter(e=>e.length>0),e.__generatedClasses&&e.__generatedClasses.forEach(t=>e.classList.add(t))}})}}
/***/},
/***/X9fM:
/***/function(e,t,i){"use strict";
/* unused harmony export GridSorterElement */
/* harmony import */i("pYlh"),i("GgZ1")
/* harmony import */;var s=i("8u2h"),r=i("ZWVL"),n=i("o5Wi"),a=i("F3iu");
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
const o=document.createElement("template");o.innerHTML="<custom-style><style>@font-face { font-family: 'vaadin-grid-sorter-icons'; src: url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAQwAA0AAAAABuwAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAEFAAAABkAAAAcfep+mUdERUYAAAP4AAAAHAAAAB4AJwAOT1MvMgAAAZgAAAA/AAAAYA8TBPpjbWFwAAAB7AAAAFUAAAFeF1fZ4mdhc3AAAAPwAAAACAAAAAgAAAAQZ2x5ZgAAAlgAAABcAAAAnMvguMloZWFkAAABMAAAAC8AAAA2C5Ap72hoZWEAAAFgAAAAHQAAACQGbQPHaG10eAAAAdgAAAAUAAAAHAoAAABsb2NhAAACRAAAABIAAAASAIwAYG1heHAAAAGAAAAAFgAAACAACwAKbmFtZQAAArQAAAECAAACZxWCgKhwb3N0AAADuAAAADUAAABZCrApUXicY2BkYGAA4rDECVrx/DZfGbhZGEDgyqNPOxH0/wNMq5kPALkcDEwgUQBWRA0dAHicY2BkYGA+8P8AAwMLAwgwrWZgZEAFbABY4QM8AAAAeJxjYGRgYOAAQiYGEICQSAAAAi8AFgAAeJxjYGY6yziBgZWBgWkm0xkGBoZ+CM34msGYkZMBFTAKoAkwODAwvmRiPvD/AIMDMxCD1CDJKjAwAgBktQsXAHicY2GAAMZQCM0EwqshbAALxAEKeJxjYGBgZoBgGQZGBhCIAPIYwXwWBhsgzcXAwcAEhIwMCi+Z/v/9/x+sSuElA4T9/4k4K1gHFwMMMILMY2QDYmaoABOQYGJABUA7WBiGNwAAJd4NIQAAAAAAAAAACAAIABAAGAAmAEAATgAAeJyNjLENgDAMBP9tIURJwQCMQccSZgk2i5fIYBDAidJjycXr7x5EPwE2wY8si7jmyBNXGo/bNBerxJNrpxhbO3/fEFpx8ZICpV+ghxJ74fAMe+h7Ox14AbrsHB14nK2QQWrDMBRER4mTkhQK3ZRQKOgCNk7oGQqhhEIX2WSlWEI1BAlkJ5CDdNsj5Ey9Rncdi38ES+jzNJo/HwTgATcoDEthhY3wBHc4CE+pfwsX5F/hGe7Vo/AcK/UhvMSz+mGXKhZU6pww8ISz3oWn1BvhgnwTnuEJf8Jz1OpFeIlX9YULDLdFi4ASHolkSR0iuYdjLak1vAequBhj21D61Nqyi6l3qWybGPjySbPHGScGJl6dP58MYcQRI0bts7mjebBqrFENH7t3qWtj0OuqHnXcW7b0HOTZFnKryRGW2hFX1m0O2vEM3opNMfTau+CS6Z3Vx6veNnEXY6jwDxhsc2gAAHicY2BiwA84GBgYmRiYGJkZmBlZGFkZ2djScyoLMgzZS/MyDQwMwLSrpYEBlIbxjQDrzgsuAAAAAAEAAf//AA94nGNgZGBg4AFiMSBmYmAEQnYgZgHzGAAD6wA2eJxjYGBgZACCKyoz1cD0o087YTQATOcIewAAAA==) format('woff'); font-weight: normal; font-style: normal; }</style></custom-style>",document.head.appendChild(o.content);
/**
 * `<vaadin-grid-sorter>` is a helper element for the `<vaadin-grid>` that provides out-of-the-box UI controls,
 * visual feedback, and handlers for sorting the grid data.
 *
 * #### Example:
 * ```html
 * <vaadin-grid-column>
 *   <template class="header">
 *     <vaadin-grid-sorter path="name.first">First name</vaadin-grid-sorter>
 *   </template>
 *   <template>[[item.name.first]]</template>
 * </vaadin-grid-column>
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name | Description
 * ----------------|----------------
 * `content` | The slotted content wrapper
 * `indicators` | The internal sorter indicators.
 * `order` | The internal sorter order
 *
 * The following state attributes are available for styling:
 *
 * Attribute    | Description | Part name
 * -------------|-------------|------------
 * `direction` | Sort direction of a sorter | :host
 *
 * @extends PolymerElement
 */
class l extends(Object(s.a)(Object(r.a)(a.a))){static get template(){return n.a`<style>:host{display:inline-flex;cursor:pointer;max-width:100%}[part=content]{flex:1 1 auto}[part=indicators]{position:relative;align-self:center;flex:none}[part=order]{display:inline;vertical-align:super}[part=indicators]::before{font-family:vaadin-grid-sorter-icons;display:inline-block}:host(:not([direction])) [part=indicators]::before{content:"\\e901"}:host([direction=asc]) [part=indicators]::before{content:"\\e900"}:host([direction=desc]) [part=indicators]::before{content:"\\e902"}</style><div part="content"><slot></slot></div><div part="indicators"><span part="order">[[_getDisplayOrder(_order)]]</span></div>`}static get is(){return"vaadin-grid-sorter"}static get properties(){return{
/**
       * JS Path of the property in the item used for sorting the data.
       */
path:String,
/**
       * How to sort the data.
       * Possible values are `asc` to use an ascending algorithm, `desc` to sort the data in
       * descending direction, or `null` for not sorting the data.
       * @type {GridSorterDirection | undefined}
       */
direction:{type:String,reflectToAttribute:!0,notify:!0,value:null},
/**
       * @type {number | null}
       * @protected
       */
_order:{type:Number,value:null},
/** @private */
_isConnected:{type:Boolean,observer:"__isConnectedChanged"}}}static get observers(){return["_pathOrDirectionChanged(path, direction)","_directionOrOrderChanged(direction, _order)"]}
/** @protected */ready(){super.ready(),this.addEventListener("click",this._onClick.bind(this))}
/** @protected */connectedCallback(){super.connectedCallback(),this._isConnected=!0}
/** @protected */disconnectedCallback(){super.disconnectedCallback(),this._isConnected=!1}
/** @private */_pathOrDirectionChanged(){this.__dispatchSorterChangedEvenIfPossible()}
/** @private */__isConnectedChanged(e,t){!1!==t&&this.__dispatchSorterChangedEvenIfPossible()}
/** @private */__dispatchSorterChangedEvenIfPossible(){void 0!==this.path&&void 0!==this.direction&&this._isConnected&&this.dispatchEvent(new CustomEvent("sorter-changed",{bubbles:!0,composed:!0}))}
/** @private */_getDisplayOrder(e){return null===e?"":e+1}
/** @private */_onClick(e){const t=this.getRootNode().activeElement;this!==t&&this.contains(t)||(e.preventDefault(),"asc"===this.direction?this.direction="desc":"desc"===this.direction?this.direction=null:this.direction="asc")}
/** @private */_directionOrOrderChanged(e,t){void 0!==e&&void 0!==t&&(/^((?!chrome|android).)*safari/i.test(navigator.userAgent)&&this.root&&this.root.querySelectorAll("*").forEach((function(e){e.style["-webkit-backface-visibility"]="visible",e.style["-webkit-backface-visibility"]=""})));// Safari has an issue with repainting shadow root element styles when a host attribute changes.
// Need this workaround (toggle any inline css property on and off) until the issue gets fixed.
}}customElements.define(l.is,l)},
/***/e8x0:
/***/function(e,t,i){"use strict";
/* unused harmony export GridSortColumnElement */
/* harmony import */var s=i("qu6e"),r=(i("X9fM"),i("o5Wi"));
/* harmony import */
/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * `<vaadin-grid-sort-column>` is a helper element for the `<vaadin-grid>`
 * that provides default header template and functionality for sorting.
 *
 * #### Example:
 * ```html
 * <vaadin-grid items="[[items]]">
 *  <vaadin-grid-sort-column path="name.first" direction="asc"></vaadin-grid-sort-column>
 *
 *  <vaadin-grid-column>
 *    ...
 * ```
 *
 */
class n extends s.a{static get template(){return r.a`<template class="header" id="headerTemplate"><vaadin-grid-sorter path="[[path]]" direction="{{direction}}">[[_getHeader(header, path)]]</vaadin-grid-sorter></template>`}static get is(){return"vaadin-grid-sort-column"}static get properties(){return{
/**
       * JS Path of the property in the item used for sorting the data.
       */
path:String,
/**
       * How to sort the data.
       * Possible values are `asc` to use an ascending algorithm, `desc` to sort the data in
       * descending direction, or `null` for not sorting the data.
       * @type {GridSorterDirection | undefined}
       */
direction:{type:String,notify:!0}}}
/** @private */_prepareHeaderTemplate(){const e=this._prepareTemplatizer(this.$.headerTemplate);// needed to override the dataHost correctly in case internal template is used.
return e.templatizer.dataHost=this,e}
/** @private */_getHeader(e,t){return e||this._generateHeader(t)}}customElements.define(n.is,n)},
/***/hThW:
/***/function(e,t,i){"use strict";
// EXPORTS
i.d(t,"a",(function(){/* binding */return a}));
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/mixins/gesture-event-listeners.js?babel-target=es6
var s=i("nduU");
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-grid/src/vaadin-grid-helpers.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/** @private */
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/utils/gestures.js?babel-target=es6
var r=i("hLn4"),n=i("hvZu");
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/legacy/polymer.dom.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-grid/src/vaadin-grid-column-reordering-mixin.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const a=e=>class extends(Object(s.a)(e)){static get properties(){return{
/**
       * Set to true to allow column reordering.
       * @attr {boolean} column-reordering-allowed
       * @type {boolean}
       */
columnReorderingAllowed:{type:Boolean,value:!1},
/** @private */
_orderBaseScope:{type:Number,value:1e7}}}static get observers(){return["_updateOrders(_columnTree, _columnTree.*)"]}ready(){super.ready(),Object(r.a)(this,"track",this._onTrackEvent),this._reorderGhost=this.shadowRoot.querySelector('[part="reorder-ghost"]'),this.addEventListener("touchstart",this._onTouchStart.bind(this)),this.addEventListener("touchmove",this._onTouchMove.bind(this)),this.addEventListener("touchend",this._onTouchEnd.bind(this)),this.addEventListener("contextmenu",this._onContextMenu.bind(this))}
/** @private */_onContextMenu(e){this.hasAttribute("reordering")&&e.preventDefault()}
/** @private */_onTouchStart(e){
// Touch event, delay activation by 100ms
this._startTouchReorderTimeout=setTimeout(()=>{this._onTrackStart({detail:{x:e.touches[0].clientX,y:e.touches[0].clientY}})},100)}
/** @private */_onTouchMove(e){this._draggedColumn&&e.preventDefault(),clearTimeout(this._startTouchReorderTimeout)}
/** @private */_onTouchEnd(){clearTimeout(this._startTouchReorderTimeout),this._onTrackEnd()}
/** @private */_onTrackEvent(e){if("start"===e.detail.state){const t=e.composedPath(),i=t[t.indexOf(this.$.header)-2];if(!i||!i._content)
// Not a header column
return;const s=this.getRootNode().activeElement;if(i._content.contains(this.getRootNode().activeElement)&&(!this._ie||!this._isFocusable(s)))
// Something was focused inside the cell
return;if(this.$.scroller.hasAttribute("column-resizing"))
// Resizing is in progress
return;this._touchDevice||
// Not a touch device
this._onTrackStart(e)}else"track"===e.detail.state?this._onTrack(e):"end"===e.detail.state&&this._onTrackEnd(e)}
/** @private */_onTrackStart(e){if(!this.columnReorderingAllowed)return;// Cancel reordering if there are draggable nodes on the event path
const t=e.path||Object(n.a)(e).path;if(t&&t.filter(e=>e.hasAttribute&&e.hasAttribute("draggable"))[0])return;const i=this._cellFromPoint(e.detail.x,e.detail.y);if(i&&-1!==i.getAttribute("part").indexOf("header-cell")){for(this._toggleAttribute("reordering",!0,this),this._draggedColumn=i._column;1===this._draggedColumn.parentElement.childElementCount;)
// This is the only column in the group, drag the whole group instead
this._draggedColumn=this._draggedColumn.parentElement;this._setSiblingsReorderStatus(this._draggedColumn,"allowed"),this._draggedColumn._reorderStatus="dragging",this._updateGhost(i),this._reorderGhost.style.visibility="visible",this._updateGhostPosition(e.detail.x,this._touchDevice?e.detail.y-50:e.detail.y),this._autoScroller()}}
/** @private */_onTrack(e){if(!this._draggedColumn)
// Reordering didn’t start. Skip this event.
return;const t=this._cellFromPoint(e.detail.x,e.detail.y);if(!t)return;const i=this._getTargetColumn(t,this._draggedColumn);this._isSwapAllowed(this._draggedColumn,i)&&this._isSwappableByPosition(i,e.detail.x)&&this._swapColumnOrders(this._draggedColumn,i),this._updateGhostPosition(e.detail.x,this._touchDevice?e.detail.y-50:e.detail.y),this._lastDragClientX=e.detail.x}
/** @private */_onTrackEnd(){this._draggedColumn&&(this._toggleAttribute("reordering",!1,this),this._draggedColumn._reorderStatus="",this._setSiblingsReorderStatus(this._draggedColumn,""),this._draggedColumn=null,this._lastDragClientX=null,this._reorderGhost.style.visibility="hidden",this.dispatchEvent(new CustomEvent("column-reorder",{detail:{columns:this._getColumnsInOrder()}})))}
/**
   * @return {!Array<!GridColumnElement>}
   * @protected
   */_getColumnsInOrder(){return this._columnTree.slice(0).pop().filter(e=>!e.hidden).sort((e,t)=>e._order-t._order)}
/**
   * @param {number} x
   * @param {number} y
   * @return {HTMLElement | undefined}
   * @protected
   */_cellFromPoint(e,t){let i;// Workaround FF58/ShadyDOM bugs
for(e=e||0,t=t||0,this._draggedColumn||this._toggleAttribute("no-content-pointer-events",!0,this.$.scroller),// Workaround a ShadyDOM bug
this._reorderGhost.hidden=!0,i=this.shadowRoot.elementFromPoint?this.shadowRoot.elementFromPoint(e,t):document.elementFromPoint(e,t),this._reorderGhost.hidden=!1;!i._column&&i.parentElement;)i="vaadin-grid-cell-content"===i.localName?i.assignedSlot.parentNode:i.parentElement;// Make sure the element is actually a cell
if(this._toggleAttribute("no-content-pointer-events",!1,this.$.scroller),i&&i._column)return i}
/**
   * @param {number} eventClientX
   * @param {number} eventClientY
   * @protected
   */_updateGhostPosition(e,t){const i=this._reorderGhost.getBoundingClientRect(),s=e-i.width/2,r=t-i.height/2,n=parseInt(this._reorderGhost._left||0),a=parseInt(this._reorderGhost._top||0);// // This is where we want to position the ghost
// Reposition the ghost
this._reorderGhost._left=n-(i.left-s),this._reorderGhost._top=a-(i.top-r),this._reorderGhost.style.transform=`translate(${this._reorderGhost._left}px, ${this._reorderGhost._top}px)`}
/**
   * @param {!Element} e
   * @return {string}
   * @protected
   */_getInnerText(e){return e.localName?
// Custom implementation needed since IE11 doesn't respect the spec in case of hidden elements
"none"===getComputedStyle(e).display?"":Array.from(e.childNodes).map(e=>this._getInnerText(e)).join(""):e.textContent}
/**
   * @param {!HTMLElement} cell
   * @return {!HTMLElement}
   * @protected
   */_updateGhost(e){const t=this._reorderGhost;t.textContent=this._getInnerText(e._content);const i=window.getComputedStyle(e);return["boxSizing","display","width","height","background","alignItems","padding","border","flex-direction","overflow"].forEach(e=>t.style[e]=i[e]),t}
/** @private */_updateOrders(e,t){void 0!==e&&void 0!==t&&(// Reset all column orders
e[0].forEach((e,t)=>e._order=0),// Set order numbers to top-level columns
class{
/**
    * @param {Array<Object>} columns array of columns to be modified
    * @param {number} scope multiplier added to base order for each column
    * @param {number} baseOrder base number used for order
    */
static _updateColumnOrders(e,t,i){let s=1;e.forEach(e=>{
// avoid multiples of 10 because they introduce and extra zero and
// causes the underlying calculations for child order goes wrong
s%10==0&&s++,e._order=i+s*t,s++})}}._updateColumnOrders(e[0],this._orderBaseScope,0))}
/**
   * @param {!GridColumnElement} column
   * @param {string} status
   * @protected
   */_setSiblingsReorderStatus(e,t){Array.from(e.parentNode.children).filter(t=>/column/.test(t.localName)&&this._isSwapAllowed(t,e)).forEach(e=>e._reorderStatus=t)}
/** @protected */_autoScroller(){if(this._lastDragClientX){const e=this._lastDragClientX-this.getBoundingClientRect().right+50,t=this.getBoundingClientRect().left-this._lastDragClientX+50;e>0?this.$.table.scrollLeft+=e/10:t>0&&(this.$.table.scrollLeft-=t/10),this._scrollHandler()}this._draggedColumn&&this.async(this._autoScroller,10)}
/**
   * @param {GridColumnElement | undefined} column1
   * @param {GridColumnElement | undefined} column2
   * @return {boolean | undefined}
   * @protected
   */_isSwapAllowed(e,t){if(e&&t){const i=e!==t,s=e.parentElement===t.parentElement,r=e.frozen===t.frozen;return i&&s&&r}}
/**
   * @param {!GridColumnElement} targetColumn
   * @param {number} clientX
   * @return {boolean}
   * @protected
   */_isSwappableByPosition(e,t){const i=Array.from(this.$.header.querySelectorAll('tr:not([hidden]) [part~="cell"]')).filter(t=>e.contains(t._column))[0],s=this.$.header.querySelector("tr:not([hidden]) [reorder-status=dragging]").getBoundingClientRect(),r=i.getBoundingClientRect();return r.left>s.left?t>r.right-s.width:t<r.left+s.width}
/**
   * @param {!GridColumnElement} column1
   * @param {!GridColumnElement} column2
   * @protected
   */_swapColumnOrders(e,t){const i=e._order;e._order=t._order,t._order=i,this._updateLastFrozen(),this._updateFirstAndLastColumn()}
/**
   * @param {HTMLElement | undefined} targetCell
   * @param {GridColumnElement} draggedColumn
   * @return {GridColumnElement | undefined}
   * @protected
   */_getTargetColumn(e,t){if(e&&t){let i=e._column;for(;i.parentElement!==t.parentElement&&i!==this;)i=i.parentElement;return i.parentElement===t.parentElement?i:e._column}}
/**
   * Fired when the columns in the grid are reordered.
   *
   * @event column-reorder
   * @param {Object} detail
   * @param {Object} detail.columns the columns in the new order
   */}
/***/},
/***/jgOO:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return r}));
/* harmony import */var s=i("pYlh");
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */const r=e=>class extends e{static get properties(){return{
/**
       * An array containing the items which will be stamped to the column template
       * instances.
       *
       * @type {Array<!GridItem> | undefined}
       */
items:Array}}static get observers(){return["_itemsChanged(items, items.*, isAttached)"]}
/** @private */_itemsChanged(e,t,i){if(i){if(!Array.isArray(e))return null==e&&(this.size=0),void(this.dataProvider===this._arrayDataProvider&&(this.dataProvider=void 0));this.size=e.length,this.dataProvider=this.dataProvider||this._arrayDataProvider,this.clearCache(),this._ensureFirstPageLoaded()}}
/**
   * @param {GridDataProviderParams} opts
   * @param {GridDataProviderCallback} cb
   * @protected
   */_arrayDataProvider(e,t){let i=(Array.isArray(this.items)?this.items:[]).slice(0);this._filters&&this._checkPaths(this._filters,"filtering",i)&&(i=this._filter(i)),this.size=i.length,e.sortOrders.length&&this._checkPaths(this._sorters,"sorting",i)&&(i=i.sort(this._multiSort.bind(this)));const s=e.page*e.pageSize,r=s+e.pageSize;t(i.slice(s,r),i.length)}
/**
   * Check array of filters/sorters for paths validity, console.warn invalid items
   * @param {!Array<!GridFilter | !GridSorter>} arrayToCheck The array of filters/sorters to check
   * @param {string} action The name of action to include in warning (filtering, sorting)
   * @param {!Array<!GridItem>} items
   * @protected
   */_checkPaths(e,t,i){if(!i.length)return!1;let r=!0;for(var n in e){const a=e[n].path;// skip simple paths
if(!a||-1===a.indexOf("."))continue;const o=a.replace(/\.[^\.]*$/,"");// a.b.c -> a.b
void 0===s.a.get(o,i[0])&&(console.warn(`Path "${a}" used for ${t} does not exist in all of the items, ${t} is disabled.`),r=!1)}return r}
/**
   * @param {unknown} a
   * @param {unknown} b
   * @return {number}
   * @protected
   */_multiSort(e,t){return this._sorters.map(i=>"asc"===i.direction?this._compare(s.a.get(i.path,e),s.a.get(i.path,t)):"desc"===i.direction?this._compare(s.a.get(i.path,t),s.a.get(i.path,e)):0).reduce((e,t)=>e||t,0)}
/**
   * @param {unknown} value
   * @return {string}
   * @protected
   */_normalizeEmptyValue(e){return[void 0,null].indexOf(e)>=0?"":isNaN(e)?e.toString():e}
/**
   * @param {unknown} a
   * @param {unknown} b
   * @return {number}
   * @protected
   */_compare(e,t){return(e=this._normalizeEmptyValue(e))<(t=this._normalizeEmptyValue(t))?-1:e>t?1:0}
/**
   * @param {!Array<!GridItem>} items
   * @return {!Array<!GridItem>}
   * @protected
   */_filter(e){return e.filter((e,t)=>0===this._filters.filter(t=>{const i=this._normalizeEmptyValue(s.a.get(t.path,e)),r=this._normalizeEmptyValue(t.value).toString().toLowerCase();return-1===i.toString().toLowerCase().indexOf(r)}).length)}}
/***/},
/***/k5YY:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return n}));
/* harmony import */var s=i("3OGf"),r=i("WE4f");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const n=e=>class extends e{static get properties(){return{
/**
       * An array containing references to items with open row details.
       * @type {Array<GridItem> | null | undefined}
       */
detailsOpenedItems:{type:Array,value:function(){return[]}},
/**
       * @type {HTMLTemplateElement}
       * @protected
       */
_rowDetailsTemplate:Object,
/**
       * Custom function for rendering the content of the row details.
       * Receives three arguments:
       *
       * - `root` The row details content DOM element. Append your content to it.
       * - `grid` The `<vaadin-grid>` element.
       * - `model` The object with the properties related with
       *   the rendered item, contains:
       *   - `model.index` The index of the item.
       *   - `model.item` The item.
       *
       * @type {GridRowDetailsRenderer | null | undefined}
       */
rowDetailsRenderer:Function,
/**
       * @type {!Array<!HTMLElement> | undefined}
       * @protected
       */
_detailsCells:{type:Array}}}static get observers(){return["_detailsOpenedItemsChanged(detailsOpenedItems.*, _rowDetailsTemplate, rowDetailsRenderer)","_rowDetailsTemplateOrRendererChanged(_rowDetailsTemplate, rowDetailsRenderer)"]}
/** @private */_rowDetailsTemplateOrRendererChanged(e,t){if(e&&t)throw new Error("You should only use either a renderer or a template for row details");if(e||t){if(e&&!e.templatizer){var i=new s.a;i._grid=this,i.dataHost=this.dataHost,i.template=e,e.templatizer=i}this._columnTree&&
// Only update the rows if the column tree has already been initialized
Array.from(this.$.items.children).forEach(e=>{e.querySelector("[part~=details-cell]")||(this._updateRow(e,this._columnTree[this._columnTree.length-1]),this._a11yUpdateRowDetailsOpened(e,!1)),// Clear any old template instances
delete e.querySelector("[part~=details-cell]")._instance}),this.detailsOpenedItems.length&&(Array.from(this.$.items.children).forEach(this._toggleDetailsCell,this),this._update())}}
/** @private */_detailsOpenedItemsChanged(e,t,i){"detailsOpenedItems.length"!==e.path&&e.value&&Array.from(this.$.items.children).forEach(e=>{this._toggleDetailsCell(e,e._item),this._a11yUpdateRowDetailsOpened(e,this._isDetailsOpened(e._item)),this._toggleAttribute("details-opened",this._isDetailsOpened(e._item),e)})}
/**
   * @param {!HTMLElement} cell
   * @protected
   */_configureDetailsCell(e){e.setAttribute("part","cell details-cell"),// Freeze the details cell, so that it does not scroll horizontally
// with the normal cells. This way it looks less weird.
this._toggleAttribute("frozen",!0,e)}
/**
   * @param {!HTMLElement} row
   * @param {!GridItem} item
   * @protected
   */_toggleDetailsCell(e,t){const i=e.querySelector('[part~="details-cell"]');if(!i)return;const s=!this._isDetailsOpened(t),n=!!i.hidden!==s;(i._instance||i._renderer)&&i.hidden===s||(i.hidden=s,s?e.style.removeProperty("padding-bottom"):(this.rowDetailsRenderer?(i._renderer=this.rowDetailsRenderer,i._renderer.call(this,i._content,this,{index:e.index,item:t})):this._rowDetailsTemplate&&!i._instance&&(
// Stamp the template
i._instance=this._rowDetailsTemplate.templatizer.createInstance(),i._content.innerHTML="",i._content.appendChild(i._instance.root),this._updateItem(e,t)),Object(r.b)(),e.style.setProperty("padding-bottom",i.offsetHeight+"px"),requestAnimationFrame(()=>this.notifyResize()))),n&&(this._updateMetrics(),this._positionItems())}
/** @protected */_updateDetailsCellHeights(){Array.from(this.$.items.querySelectorAll('[part~="details-cell"]:not([hidden])')).forEach(e=>{e.parentElement.style.setProperty("padding-bottom",e.offsetHeight+"px")})}
/**
   * @param {!GridItem} item
   * @return {boolean}
   * @protected
   */_isDetailsOpened(e){return this.detailsOpenedItems&&-1!==this._getItemIndexInArray(e,this.detailsOpenedItems)}
/**
   * Open the details row of a given item.
   * @param {!GridItem} item
   */openItemDetails(e){this._isDetailsOpened(e)||this.push("detailsOpenedItems",e)}
/**
   * Close the details row of a given item.
   * @param {!GridItem} item
   */closeItemDetails(e){this._isDetailsOpened(e)&&this.splice("detailsOpenedItems",this._getItemIndexInArray(e,this.detailsOpenedItems),1)}
/** @private */_detailsOpenedInstanceChangedCallback(e,t){super._detailsOpenedInstanceChangedCallback&&super._detailsOpenedInstanceChangedCallback(e,t),t?this.openItemDetails(e.item):this.closeItemDetails(e.item)}}
/***/},
/***/kGb3:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return s}));
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const s=e=>class extends e{static get observers(){return["_a11yUpdateGridSize(size, _columnTree, _columnTree.*)"]}
/** @private */_a11yGetHeaderRowCount(e){return e.filter(e=>e.some(e=>e._headerTemplate||e.headerRenderer||e.path||e.header)).length}
/** @private */_a11yGetFooterRowCount(e){return e.filter(e=>e.some(e=>e._headerTemplate||e.headerRenderer)).length}
/** @private */_a11yUpdateGridSize(e,t){if(void 0===e||void 0===t)return;const i=t[t.length-1];this.$.table.setAttribute("aria-rowcount",e+this._a11yGetHeaderRowCount(t)+this._a11yGetFooterRowCount(t)),this.$.table.setAttribute("aria-colcount",i&&i.length||0),this._a11yUpdateHeaderRows(),this._a11yUpdateFooterRows()}
/** @protected */_a11yUpdateHeaderRows(){Array.from(this.$.header.children).forEach((e,t)=>e.setAttribute("aria-rowindex",t+1))}
/** @protected */_a11yUpdateFooterRows(){Array.from(this.$.footer.children).forEach((e,t)=>e.setAttribute("aria-rowindex",this._a11yGetHeaderRowCount(this._columnTree)+this.size+t+1))}
/**
   * @param {!HTMLElement} row
   * @param {number} index
   * @protected
   */_a11yUpdateRowRowindex(e,t){e.setAttribute("aria-rowindex",t+this._a11yGetHeaderRowCount(this._columnTree)+1)}
/**
   * @param {!HTMLElement} row
   * @param {boolean} selected
   * @protected
   */_a11yUpdateRowSelected(e,t){
// Jaws reads selection only for rows, NVDA only for cells
e.setAttribute("aria-selected",Boolean(t)),Array.from(e.children).forEach(e=>e.setAttribute("aria-selected",Boolean(t)))}
/**
   * @param {!HTMLElement} row
   * @param {number} level
   * @protected
   */_a11yUpdateRowLevel(e,t){e.setAttribute("aria-level",t+1)}
/**
   * @param {!HTMLElement} row
   * @param {boolean} detailsOpened
   * @protected
   */_a11yUpdateRowDetailsOpened(e,t){Array.from(e.children).forEach(e=>{"boolean"==typeof t?e.setAttribute("aria-expanded",t):e.hasAttribute("aria-expanded")&&e.removeAttribute("aria-expanded")})}
/**
   * @param {!HTMLElement} row
   * @param {!HTMLElement} detailsCell
   * @protected
   */_a11ySetRowDetailsCell(e,t){Array.from(e.children).forEach(e=>{e!==t&&e.setAttribute("aria-controls",t.id)})}
/**
   * @param {!HTMLElement} row
   * @param {number} colspan
   * @protected
   */_a11yUpdateCellColspan(e,t){e.setAttribute("aria-colspan",Number(t))}
/** @protected */_a11yUpdateSorters(){Array.from(this.querySelectorAll("vaadin-grid-sorter")).forEach(e=>{let t=e.parentNode;for(;t&&"vaadin-grid-cell-content"!==t.localName;)t=t.parentNode;if(t&&t.assignedSlot){t.assignedSlot.parentNode.setAttribute("aria-sort",{asc:"ascending",desc:"descending"}[String(e.direction)]||"none")}})}}
/***/},
/***/kgTn:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return n}));
/* harmony import */var s=i("9nmN"),r=i("Y40L");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const n=e=>class extends e{
/** @private */
get _timeouts(){return{SCROLLING:500,IGNORE_WHEEL:500}}static get properties(){return{
/**
       * Cached array of frozen cells
       * @private
       */
_frozenCells:{type:Array,value:()=>[]},
/** @private */
_rowWithFocusedElement:Element,
/** @private */
_deltaYAcc:{type:Number,value:0},
/** @private */
_useSticky:{type:Boolean,value:window.CSS&&window.CSS.supports&&(window.CSS.supports("position","sticky")||window.CSS.supports("position","-webkit-sticky"))}}}static get observers(){return["_scrollViewportHeightUpdated(_viewportHeight)"]}
/**
   * Override (from iron-scroll-target-behavior) to avoid document scroll
   * @private
   */set _scrollTop(e){this.$.table.scrollTop=e}
/** @private */get _scrollTop(){return this.$.table.scrollTop}constructor(){super(),this._scrollLineHeight=this._getScrollLineHeight()}
/**
   * @returns {Number|undefined} - The browser's default font-size in pixels
   * @private
   */_getScrollLineHeight(){const e=document.createElement("div");e.style.fontSize="initial",e.style.display="none",document.body.appendChild(e);const t=window.getComputedStyle(e).fontSize;return document.body.removeChild(e),t?window.parseInt(t):void 0}
/** @private */_scrollViewportHeightUpdated(e){this._scrollPageHeight=e-this.$.header.clientHeight-this.$.footer.clientHeight-this._scrollLineHeight}
/** @protected */ready(){super.ready(),// Preserve accessor to the legacy scrolling functionality
this.$.outerscroller=document.createElement("div"),this.scrollTarget=this.$.table,this.addEventListener("wheel",this._onWheel),this.$.items.addEventListener("focusin",e=>{const t=e.composedPath().indexOf(this.$.items);this._rowWithFocusedElement=e.composedPath()[t-1]}),this.$.items.addEventListener("focusout",()=>this._rowWithFocusedElement=void 0),// Reordering the physical rows cancels the user's grab of the scroll bar handle on Safari.
// Need to defer reordering until the user lets go of the scroll bar handle.
this.scrollTarget.addEventListener("mousedown",()=>this.__mouseDown=!0),this.scrollTarget.addEventListener("mouseup",()=>{this.__mouseDown=!1,this.__pendingReorder&&(this.__pendingReorder=!1,setTimeout(()=>this._reorderRows(),this._timeouts.SCROLLING))})}
/**
   * Scroll to a specific row index in the virtual list. Note that the row index is
   * not always the same for any particular item. For example, sorting/filtering/expanding
   * or collapsing hierarchical items can affect the row index related to an item.
   *
   * @param {number} index Row index to scroll to
   */scrollToIndex(e){this._accessIronListAPI(()=>super.scrollToIndex(e))}
/** @private */_onWheel(e){if(e.ctrlKey||this._hasScrolledAncestor(e.target,e.deltaX,e.deltaY))return;const t=this.$.table;let i=e.deltaY;if(e.deltaMode===WheelEvent.DOM_DELTA_LINE?
// Scrolling by "lines of text" instead of pixels
i*=this._scrollLineHeight:e.deltaMode===WheelEvent.DOM_DELTA_PAGE&&(
// Scrolling by "pages" instead of pixels
i*=this._scrollPageHeight),this._wheelAnimationFrame)
// Skip new wheel events while one is being processed
return this._deltaYAcc+=i,void e.preventDefault();i+=this._deltaYAcc,this._deltaYAcc=0,this._wheelAnimationFrame=!0,this._debouncerWheelAnimationFrame=s.a.debounce(this._debouncerWheelAnimationFrame,r.a,()=>this._wheelAnimationFrame=!1);var n=Math.abs(e.deltaX)+Math.abs(i);this._canScroll(t,e.deltaX,i)?(e.preventDefault(),t.scrollTop+=i,t.scrollLeft+=e.deltaX,this._scrollHandler(),this._hasResidualMomentum=!0,this._ignoreNewWheel=!0,this._debouncerIgnoreNewWheel=s.a.debounce(this._debouncerIgnoreNewWheel,r.d.after(this._timeouts.IGNORE_WHEEL),()=>this._ignoreNewWheel=!1)):this._hasResidualMomentum&&n<=this._previousMomentum||this._ignoreNewWheel?e.preventDefault():n>this._previousMomentum&&(this._hasResidualMomentum=!1),this._previousMomentum=n}
/**
   * Determines if the element has an ancestor prior to this
   * cell content that handles the scroll delta
   * @private
   */_hasScrolledAncestor(e,t,i){return"vaadin-grid-cell-content"!==e.localName&&(!(!this._canScroll(e,t,i)||-1===["auto","scroll"].indexOf(getComputedStyle(e).overflow))||(e!==this&&e.parentElement?this._hasScrolledAncestor(e.parentElement,t,i):void 0))}
/**
   * Determines if the the given scroll deltas can be applied to the element
   * (fully or partially)
   * @private
   */_canScroll(e,t,i){return i>0&&e.scrollTop<e.scrollHeight-e.offsetHeight||i<0&&e.scrollTop>0||t>0&&e.scrollLeft<e.scrollWidth-e.offsetWidth||t<0&&e.scrollLeft>0}
/** @private */_scheduleScrolling(){this._scrollingFrame||(
// Defer setting state attributes to avoid Edge hiccups
this._scrollingFrame=requestAnimationFrame(()=>this._toggleAttribute("scrolling",!0,this.$.scroller))),this._debounceScrolling=s.a.debounce(this._debounceScrolling,r.d.after(this._timeouts.SCROLLING),()=>{cancelAnimationFrame(this._scrollingFrame),delete this._scrollingFrame,this._toggleAttribute("scrolling",!1,this.$.scroller),this._reorderRows()})}
/** @private */_afterScroll(){this._translateStationaryElements(),this.hasAttribute("reordering")||this._scheduleScrolling(),this._updateOverflow()}
/** @private */_updateOverflow(){
// Set overflow styling attributes
let e="";const t=this.$.table;t.scrollTop<t.scrollHeight-t.clientHeight&&(e+=" bottom"),t.scrollTop>0&&(e+=" top"),t.scrollLeft<t.scrollWidth-t.clientWidth&&(e+=" right"),t.scrollLeft>0&&(e+=" left"),this._debounceOverflow=s.a.debounce(this._debounceOverflow,r.a,()=>{const t=e.trim();t.length>0&&this.getAttribute("overflow")!==t?this.setAttribute("overflow",t):0==t.length&&this.hasAttribute("overflow")&&this.removeAttribute("overflow")})}
/**
   * Correct order needed for preserving correct tab order between cell contents.
   * @private
   */_reorderRows(){if(this.__mouseDown)return void(this.__pendingReorder=!0);const e=this.$.items,t=e.querySelectorAll("tr");if(!t.length)return;const i=this._virtualStart+this._vidxOffset,s=this._rowWithFocusedElement||Array.from(t).filter(e=>!e.hidden)[0];// Which row to use as a target?
if(!s)
// All rows are hidden, don't reorder
return;// Where the target row should be?
const r=s.index-i,n=Array.from(t).indexOf(s)-r;// Reodrer the DOM elements to keep the target row at the target physical index
if(n>0)for(let i=0;i<n;i++)e.appendChild(t[i]);else if(n<0)for(let i=t.length+n;i<t.length;i++)e.insertBefore(t[i],t[0]);// Due to a rendering bug, reordering the rows can make the sticky header disappear on Safari
// if the grid is used inside of a flex box. This is a workaround for the issue.
if(this._safari){const{transform:e}=this.$.header.style;this.$.header.style.transform="",setTimeout(()=>this.$.header.style.transform=e)}}
/** @protected */_frozenCellsChanged(){this._debouncerCacheElements=s.a.debounce(this._debouncerCacheElements,r.c,()=>{Array.from(this.shadowRoot.querySelectorAll('[part~="cell"]')).forEach((function(e){e.style.transform=""})),this._frozenCells=Array.prototype.slice.call(this.$.table.querySelectorAll("[frozen]")),this._updateScrollerMeasurements(),this._translateStationaryElements()}),this._updateLastFrozen()}
/** @protected */_updateScrollerMeasurements(){this._frozenCells.length>0&&this.__isRTL&&(this.__scrollerMetrics={scrollWidth:this.$.table.scrollWidth,clientWidth:this.$.table.clientWidth})}
/** @protected */_updateLastFrozen(){if(!this._columnTree)return;const e=this._columnTree[this._columnTree.length-1].slice(0);e.sort((e,t)=>e._order-t._order);const t=e.reduce((e,t,i)=>(t._lastFrozen=!1,t.frozen&&!t.hidden?i:e),void 0);void 0!==t&&(e[t]._lastFrozen=!0)}
/** @private */_translateStationaryElements(){const e=Math.max(0,this._scrollLeft),t=Math.max(0,this._scrollTop);let i=0,s=0,r=0;if(this._useSticky||(i=e,s=t,r=this.$.table.clientHeight-this.$.footer.offsetHeight-this.$.footer.offsetTop),this.$.header.style.transform=this._getTranslate(-e+i,s),this.$.footer.style.transform=this._getTranslate(-e+i,s+r),this.$.items.style.transform=this._getTranslate(-e+i,0),this._frozenCells.length>0){const e=this.__isRTL?this.__getNormalizedScrollLeft(this.$.table)+this.__scrollerMetrics.clientWidth-this.__scrollerMetrics.scrollWidth:this._scrollLeft;for(var n=this._getTranslate(e,0),a=0;a<this._frozenCells.length;a++)this._frozenCells[a].style.transform=n}}
/** @private */_getTranslate(e,t){return`translate(${e}px, ${t}px)`}}
/***/},
/***/mLZy:
/***/function(e,t,i){"use strict";
// EXPORTS
i.d(t,"a",(function(){/* binding */return m}));
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/utils/render-status.js?babel-target=es6
var s=i("7BTU"),r=i("Y40L"),n=i("WE4f"),a=(i("pYlh"),i("JxY1")),o=i("uo8t"),l=i("x3pe"),h=i("9nmN"),d=navigator.userAgent.match(/iP(?:hone|ad;(?: U;)? CPU) OS (\d+)/),c=d&&d[1]>=8,_=r.a,u=r.b,p=r.c;
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/utils/async.js?babel-target=es6
/**
 * @constructor
 */
const g=Object(l.a)({behaviors:[a.a,o.a],
/**
   * The ratio of hidden tiles that should remain in the scroll direction.
   * Recommended value ~0.5, so it will distribute tiles evenly in both directions.
   */
_ratio:.5,
/**
   * The padding-top value for the list.
   */
_scrollerPaddingTop:0,
/**
   * This value is the same as `scrollTop`.
   */
_scrollPosition:0,
/**
   * The sum of the heights of all the tiles in the DOM.
   */
_physicalSize:0,
/**
   * The average `offsetHeight` of the tiles observed till now.
   */
_physicalAverage:0,
/**
   * The number of tiles which `offsetHeight` > 0 observed until now.
   */
_physicalAverageCount:0,
/**
   * The Y position of the item rendered in the `_physicalStart`
   * tile relative to the scrolling list.
   */
_physicalTop:0,
/**
   * The number of items in the list.
   */
_virtualCount:0,
/**
   * The estimated scroll height based on `_physicalAverage`
   */
_estScrollHeight:0,
/**
   * The scroll height of the dom node
   */
_scrollHeight:0,
/**
   * The height of the list. This is referred as the viewport in the context of list.
   */
_viewportHeight:0,
/**
   * The width of the list. This is referred as the viewport in the context of list.
   */
_viewportWidth:0,
/**
   * An array of DOM nodes that are currently in the tree
   * @type {?Array<!TemplatizerNode>}
   */
_physicalItems:null,
/**
   * An array of heights for each item in `_physicalItems`
   * @type {?Array<number>}
   */
_physicalSizes:null,
/**
   * A cached value for the first visible index.
   * See `firstVisibleIndex`
   * @type {?number}
   */
_firstVisibleIndexVal:null,
/**
   * A Polymer collection for the items.
   * @type {?Polymer.Collection}
   */
_collection:null,
/**
   * A cached value for the last visible index.
   * See `lastVisibleIndex`
   * @type {?number}
   */
_lastVisibleIndexVal:null,
/**
   * The max number of pages to render. One page is equivalent to the height of the list.
   */
_maxPages:2,
/**
   * The virtual index of the focused item.
   */
_focusedVirtualIndex:-1,
/**
   * The maximum items per row
   */
_itemsPerRow:1,
/**
   * The height of the row in grid layout.
   */
_rowHeight:0,
/**
   * The cost of stamping a template in ms.
   */
_templateCost:0,
/**
   * The bottom of the physical content.
   */
get _physicalBottom(){return this._physicalTop+this._physicalSize},
/**
   * The bottom of the scroll.
   */
get _scrollBottom(){return this._scrollPosition+this._viewportHeight},
/**
   * The n-th item rendered in the last physical item.
   */
get _virtualEnd(){return this._virtualStart+this._physicalCount-1},
/**
   * The height of the physical content that isn't on the screen.
   */
get _hiddenContentSize(){return(this.grid?this._physicalRows*this._rowHeight:this._physicalSize)-this._viewportHeight},
/**
   * The maximum scroll top value.
   */
get _maxScrollTop(){return this._estScrollHeight-this._viewportHeight+this._scrollOffset},
/**
   * The largest n-th value for an item such that it can be rendered in `_physicalStart`.
   */
get _maxVirtualStart(){var e=this._convertIndexToCompleteRow(this._virtualCount);return Math.max(0,e-this._physicalCount)},set _virtualStart(e){e=this._clamp(e,0,this._maxVirtualStart),this.grid&&(e-=e%this._itemsPerRow),this._virtualStartVal=e},get _virtualStart(){return this._virtualStartVal||0},
/**
   * The k-th tile that is at the top of the scrolling list.
   */
set _physicalStart(e){(e%=this._physicalCount)<0&&(e=this._physicalCount+e),this.grid&&(e-=e%this._itemsPerRow),this._physicalStartVal=e},get _physicalStart(){return this._physicalStartVal||0},
/**
   * The k-th tile that is at the bottom of the scrolling list.
   */
get _physicalEnd(){return(this._physicalStart+this._physicalCount-1)%this._physicalCount},set _physicalCount(e){this._physicalCountVal=e},get _physicalCount(){return this._physicalCountVal||0},
/**
   * An optimal physical size such that we will have enough physical items
   * to fill up the viewport and recycle when the user scrolls.
   *
   * This default value assumes that we will at least have the equivalent
   * to a viewport of physical items above and below the user's viewport.
   */
get _optPhysicalSize(){return 0===this._viewportHeight?1/0:this._viewportHeight*this._maxPages},
/**
   * True if the current list is visible.
   */
get _isVisible(){return Boolean(this.offsetWidth||this.offsetHeight)},
/**
   * Gets the index of the first visible item in the viewport.
   *
   * @type {number}
   */
get firstVisibleIndex(){var e=this._firstVisibleIndexVal;if(null==e){var t=this._physicalTop+this._scrollOffset;e=this._iterateItems((function(e,i){return(t+=this._getPhysicalSizeIncrement(e))>this._scrollPosition?this.grid?i-i%this._itemsPerRow:i:// Handle a partially rendered final row in grid mode
this.grid&&this._virtualCount-1===i?i-i%this._itemsPerRow:void 0}))||0,this._firstVisibleIndexVal=e}return e},
/**
   * Gets the index of the last visible item in the viewport.
   *
   * @type {number}
   */
get lastVisibleIndex(){var e=this._lastVisibleIndexVal;if(null==e){if(this.grid)e=Math.min(this._virtualCount,this.firstVisibleIndex+this._estRowsInView*this._itemsPerRow-1);else{var t=this._physicalTop+this._scrollOffset;this._iterateItems((function(i,s){t<this._scrollBottom&&(e=s),t+=this._getPhysicalSizeIncrement(i)}))}this._lastVisibleIndexVal=e}return e},get _scrollOffset(){return this._scrollerPaddingTop},attached:function(){this._debounce("_render",this._render,_),// `iron-resize` is fired when the list is attached if the event is added
// before attached causing unnecessary work.
this.listen(this,"iron-resize","_resizeHandler")},detached:function(){this.unlisten(this,"iron-resize","_resizeHandler")},
/**
   * Invoke this method if you dynamically update the viewport's
   * size or CSS padding.
   *
   * @method updateViewportBoundaries
   */
updateViewportBoundaries:function(){var e=window.getComputedStyle(this);this._scrollerPaddingTop=this.scrollTarget===this?0:parseInt(e["padding-top"],10),this._isRTL=Boolean("rtl"===e.direction),this._viewportWidth=this.$.items.offsetWidth,this._viewportHeight=this._scrollTargetHeight,this.grid&&this._updateGridMetrics()},
/**
   * Recycles the physical items when needed.
   */
_scrollHandler:function(){var e=Math.max(0,Math.min(this._maxScrollTop,this._scrollTop)),t=e-this._scrollPosition,i=t>=0;// Random access.
if(// Track the current scroll position.
this._scrollPosition=e,// Clear indexes for first and last visible indexes.
this._firstVisibleIndexVal=null,this._lastVisibleIndexVal=null,Math.abs(t)>this._physicalSize&&this._physicalSize>0){t-=this._scrollOffset;var s=Math.round(t/this._physicalAverage)*this._itemsPerRow;this._virtualStart=this._virtualStart+s,this._physicalStart=this._physicalStart+s,// Estimate new physical offset.
this._physicalTop=Math.floor(this._virtualStart/this._itemsPerRow)*this._physicalAverage,this._update()}else if(this._physicalCount>0){var r=this._getReusables(i);i?(this._physicalTop=r.physicalTop,this._virtualStart=this._virtualStart+r.indexes.length,this._physicalStart=this._physicalStart+r.indexes.length):(this._virtualStart=this._virtualStart-r.indexes.length,this._physicalStart=this._physicalStart-r.indexes.length),this._update(r.indexes,i?null:r.indexes),this._debounce("_increasePoolIfNeeded",this._increasePoolIfNeeded.bind(this,0),p)}},
/**
   * Returns an object that contains the indexes of the physical items
   * that might be reused and the physicalTop.
   *
   * @param {boolean} fromTop If the potential reusable items are above the scrolling region.
   */
_getReusables:function(e){var t,i,s,r=[],n=this._hiddenContentSize*this._ratio,a=this._virtualStart,o=this._virtualEnd,l=this._physicalCount,h=this._physicalTop+this._scrollOffset,d=this._physicalBottom+this._scrollOffset,c=this._scrollTop,_=this._scrollBottom;// eslint-disable-next-line no-constant-condition
for(e?(t=this._physicalStart,i=c-h):(t=this._physicalEnd,i=d-_);i-=s=this._getPhysicalSizeIncrement(t),!(r.length>=l||i<=n);)if(e){
// Check that index is within the valid range.
if(o+r.length+1>=this._virtualCount)break;// Check that the index is not visible.
if(h+s>=c-this._scrollOffset)break;r.push(t),h+=s,t=(t+1)%l}else{
// Check that index is within the valid range.
if(a-r.length<=0)break;// Check that the index is not visible.
if(h+this._physicalSize-s<=_)break;r.push(t),h-=s,t=0===t?l-1:t-1}return{indexes:r,physicalTop:h-this._scrollOffset}},
/**
   * Update the list of items, starting from the `_virtualStart` item.
   * @param {!Array<number>=} itemSet
   * @param {!Array<number>=} movingUp
   */
_update:function(e,t){if(!(e&&0===e.length||0===this._physicalCount)){// Adjust offset after measuring.
if(this._manageFocus(),this._assignModels(e),this._updateMetrics(e),t)for(;t.length;){var i=t.pop();this._physicalTop-=this._getPhysicalSizeIncrement(i)}this._positionItems(),this._updateScrollerSize()}},_isClientFull:function(){return 0!=this._scrollBottom&&this._physicalBottom-1>=this._scrollBottom&&this._physicalTop<=this._scrollPosition},
/**
   * Increases the pool size.
   */
_increasePoolIfNeeded:function(e){var t=this._clamp(this._physicalCount+e,3,this._virtualCount-this._virtualStart),i=(t=this._convertIndexToCompleteRow(t))-this._physicalCount,s=Math.round(.5*this._physicalCount);if(!(i<0)){if(i>0){var r=window.performance.now();// Concat arrays in place.
[].push.apply(this._physicalItems,this._createPool(i));// Push 0s into physicalSizes. Can't use Array.fill because IE11 doesn't support it.
for(var n=0;n<i;n++)this._physicalSizes.push(0);this._physicalCount=this._physicalCount+i,// Update the physical start if it needs to preserve the model of the focused item.
// In this situation, the focused item is currently rendered and its model would
// have changed after increasing the pool if the physical start remained unchanged.
this._physicalStart>this._physicalEnd&&this._isIndexRendered(this._focusedVirtualIndex)&&this._getPhysicalIndex(this._focusedVirtualIndex)<this._physicalEnd&&(this._physicalStart=this._physicalStart+i),this._update(),this._templateCost=(window.performance.now()-r)/i,s=Math.round(.5*this._physicalCount)}// The upper bounds is not fixed when dealing with a grid that doesn't
// fill it's last row with the exact number of items per row.
this._virtualEnd>=this._virtualCount-1||0===s||(this._isClientFull()?this._physicalSize<this._optPhysicalSize&&
// Yield and increase the pool during idle time until the physical size is optimal.
this._debounce("_increasePoolIfNeeded",this._increasePoolIfNeeded.bind(this,this._clamp(Math.round(50/this._templateCost),1,s)),u):this._debounce("_increasePoolIfNeeded",this._increasePoolIfNeeded.bind(this,s),p))}},
/**
   * Renders the a new list.
   */
_render:function(){if(this.isAttached&&this._isVisible)if(0!==this._physicalCount){var e=this._getReusables(!0);this._physicalTop=e.physicalTop,this._virtualStart=this._virtualStart+e.indexes.length,this._physicalStart=this._physicalStart+e.indexes.length,this._update(e.indexes),this._update(),this._increasePoolIfNeeded(0)}else this._virtualCount>0&&(
// Initial render
this.updateViewportBoundaries(),this._increasePoolIfNeeded(3))},
/**
   * Called when the items have changed. That is, reassignments
   * to `items`, splices or updates to a single item.
   */
_itemsChanged:function(e){"items"===e.path&&(this._virtualStart=0,this._physicalTop=0,this._virtualCount=this.items?this.items.length:0,this._collection=(this.items,null),this._physicalIndexForKey={},this._firstVisibleIndexVal=null,this._lastVisibleIndexVal=null,this._physicalCount=this._physicalCount||0,this._physicalItems=this._physicalItems||[],this._physicalSizes=this._physicalSizes||[],this._physicalStart=0,this._scrollTop>this._scrollOffset&&this._resetScrollPosition(0),this._removeFocusedItem(),this._debounce("_render",this._render,_))},
/**
   * Executes a provided function per every physical index in `itemSet`
   * `itemSet` default value is equivalent to the entire set of physical indexes.
   *
   * @param {!function(number, number)} fn
   * @param {!Array<number>=} itemSet
   */
_iterateItems:function(e,t){var i,s,r,n;if(2===arguments.length&&t){for(n=0;n<t.length;n++)if(i=t[n],s=this._computeVidx(i),null!=(r=e.call(this,i,s)))return r}else{for(i=this._physicalStart,s=this._virtualStart;i<this._physicalCount;i++,s++)if(null!=(r=e.call(this,i,s)))return r;for(i=0;i<this._physicalStart;i++,s++)if(null!=(r=e.call(this,i,s)))return r}},
/**
   * Returns the virtual index for a given physical index
   *
   * @param {number} pidx Physical index
   * @return {number}
   */
_computeVidx:function(e){return e>=this._physicalStart?this._virtualStart+(e-this._physicalStart):this._virtualStart+(this._physicalCount-this._physicalStart)+e},
/**
   * Updates the height for a given set of items.
   *
   * @param {!Array<number>=} itemSet
   */
_updateMetrics:function(e){
// Sometimes the call is schedule before Grid is hidden
// but it happens when Grid is already hidden.
// When this happens, there might be some issues as described
// here https://github.com/vaadin/web-components/issues/2127.
// Skipping any calculation for a hidden Grid.
if(this._isVisible){// Make sure we distributed all the physical items
// so we can measure them.
Object(n.b)();var t=0,i=0,s=this._physicalAverageCount,r=this._physicalAverage;this._iterateItems((function(e,s){i+=this._physicalSizes[e],this._physicalSizes[e]=this._physicalItems[e].offsetHeight,t+=this._physicalSizes[e],this._physicalAverageCount+=this._physicalSizes[e]?1:0}),e),this.grid?(this._updateGridMetrics(),this._physicalSize=Math.ceil(this._physicalCount/this._itemsPerRow)*this._rowHeight):(i=1===this._itemsPerRow?i:Math.ceil(this._physicalCount/this._itemsPerRow)*this._rowHeight,this._physicalSize=this._physicalSize+t-i,this._itemsPerRow=1),// Update the average if it measured something.
this._physicalAverageCount!==s&&(this._physicalAverage=Math.round((r*s+t)/this._physicalAverageCount))}},
/**
   * Updates the position of the physical items.
   */
_positionItems:function(){this._adjustScrollPosition();var e=this._physicalTop;this._iterateItems((function(t,i){this.translate3d(0,e+"px",0,this._physicalItems[t]),e+=this._physicalSizes[t]}))},_getPhysicalSizeIncrement:function(e){return this.grid?this._computeVidx(e)%this._itemsPerRow!=this._itemsPerRow-1?0:this._rowHeight:this._physicalSizes[e]},
/**
   * Adjusts the scroll position when it was overestimated.
   */
_adjustScrollPosition:function(){var e=0===this._virtualStart?this._physicalTop:Math.min(this._scrollPosition+this._physicalTop,0);// Note: the delta can be positive or negative.
if(0!==e){this._physicalTop=this._physicalTop-e;var t=this._scrollTop;// juking scroll position during interial scrolling on iOS is no bueno
!c&&t>0&&this._resetScrollPosition(t-e)}},
/**
   * Sets the position of the scroll.
   */
_resetScrollPosition:function(e){this.scrollTarget&&e>=0&&(this._scrollTop=e,this._scrollPosition=this._scrollTop)},
/**
   * Sets the scroll height, that's the height of the content,
   *
   * @param {boolean=} forceUpdate If true, updates the height no matter what.
   */
_updateScrollerSize:function(e){this.grid?this._estScrollHeight=this._virtualRowCount*this._rowHeight:this._estScrollHeight=this._physicalBottom+Math.max(this._virtualCount-this._physicalCount-this._virtualStart,0)*this._physicalAverage,// Amortize height adjustment, so it won't trigger large repaints too often.
((e=(e=(e=e||0===this._scrollHeight)||this._scrollPosition>=this._estScrollHeight-this._physicalSize)||this.grid&&this.$.items.style.height<this._estScrollHeight)||Math.abs(this._estScrollHeight-this._scrollHeight)>=this._viewportHeight)&&(this.$.items.style.height=this._estScrollHeight+"px",this._scrollHeight=this._estScrollHeight)},
/**
   * Scroll to a specific index in the virtual list regardless
   * of the physical items in the DOM tree.
   *
   * @method scrollToIndex
   * @param {number} idx The index of the item
   */
scrollToIndex:function(e){if(!("number"!=typeof e||e<0||e>this.items.length-1)&&(Object(n.b)(),0!==this._physicalCount))// Items should have been rendered prior scrolling to an index.
{e=this._clamp(e,0,this._virtualCount-1),// Update the virtual start only when needed.
(!this._isIndexRendered(e)||e>=this._maxVirtualStart)&&(this._virtualStart=this.grid?e-2*this._itemsPerRow:e-1),this._manageFocus(),this._assignModels(),this._updateMetrics(),// Estimate new physical offset.
this._physicalTop=Math.floor(this._virtualStart/this._itemsPerRow)*this._physicalAverage;// scroll to the item as much as we can.
for(var t=this._physicalStart,i=this._virtualStart,s=0,r=this._hiddenContentSize;i<e&&s<=r;)s+=this._getPhysicalSizeIncrement(t),t=(t+1)%this._physicalCount,i++;this._updateScrollerSize(!0),this._positionItems(),this._resetScrollPosition(this._physicalTop+this._scrollOffset+s),this._increasePoolIfNeeded(0),// clear cached visible index.
this._firstVisibleIndexVal=null,this._lastVisibleIndexVal=null}},
/**
   * Reset the physical average and the average count.
   */
_resetAverage:function(){this._physicalAverage=0,this._physicalAverageCount=0},
/**
   * A handler for the `iron-resize` event triggered by `IronResizableBehavior`
   * when the element is resized.
   */
_resizeHandler:function(){this._debounce("_render",(function(){
// clear cached visible index.
this._firstVisibleIndexVal=null,this._lastVisibleIndexVal=null,// Skip the resize event on touch devices when the address bar slides up.
this.updateViewportBoundaries(),this._isVisible?(
// Reinstall the scroll event listener.
this.toggleScrollListener(!0),this._resetAverage(),this._render()):
// Uninstall the scroll event listener.
this.toggleScrollListener(!1)}),_)},
/**
   * Converts a random index to the index of the item that completes it's row.
   * Allows for better order and fill computation when grid == true.
   */
_convertIndexToCompleteRow:function(e){
// when grid == false _itemPerRow can be unset.
return this._itemsPerRow=this._itemsPerRow||1,this.grid?Math.ceil(e/this._itemsPerRow)*this._itemsPerRow:e},_isIndexRendered:function(e){return e>=this._virtualStart&&e<=this._virtualEnd},_getPhysicalIndex:function(e){return(this._physicalStart+(e-this._virtualStart))%this._physicalCount},_clamp:function(e,t,i){return Math.min(i,Math.max(t,e))},_debounce:function(e,t,i){this._debouncers=this._debouncers||{},this._debouncers[e]=h.a.debounce(this._debouncers[e],i,t.bind(this)),Object(h.b)(this._debouncers[e])}});
// CONCATENATED MODULE: ./node_modules/@vaadin/vaadin-grid/src/vaadin-grid-scroller.js?babel-target=es6
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * This Element is used internally by vaadin-grid.
 *
 * @implements PolymerIronList
 * @extends HTMLElement
 */class m extends g{static get is(){return"vaadin-grid-scroller"}static get properties(){return{size:{type:Number,notify:!0},
/**
       * @type {number}
       * @protected
       */
_vidxOffset:{value:0}}}static get observers(){return["_effectiveSizeChanged(_effectiveSize)"]}
/** @protected */connectedCallback(){super.connectedCallback(),this._scrollHandler()}
/**
   * @param {!HTMLTableRowElement} item
   * @param {number} index
   * @protected
   */_updateScrollerItem(e,t){}
/** @protected */_afterScroll(){}
/** @protected */_getRowTarget(){}
/** @protected */_createScrollerRows(){}
/** @protected */_canPopulate(){}
/**
   * @param {number} index
   * @protected
   */scrollToIndex(e){this._warnPrivateAPIAccess("scrollToIndex"),this._scrollingToIndex=!0,e=Math.min(Math.max(e,0),this._effectiveSize-1),this.$.table.scrollTop=e/this._effectiveSize*(this.$.table.scrollHeight-this.$.table.offsetHeight),// We need to run the iron-list scroll handler here in order to recalculate the scaling from effective size to
// virtual size after changing the scroll position. However we don't want to trigger updates to the items / rows
// in this step, which could result in data provider requests for the previous viewport
this._preventItemUpdates=!0,this._scrollHandler(),this._preventItemUpdates=!1,this._accessIronListAPI(()=>this._maxScrollTop)&&this._virtualCount<this._effectiveSize&&this._adjustVirtualIndexOffset(1e6),this._accessIronListAPI(()=>super.scrollToIndex(e-this._vidxOffset)),this._scrollHandler();// Ensure scroll position
const t=Array.from(this.$.items.children).filter(t=>t.index===e)[0];if(t){const e=t.getBoundingClientRect().top-this.$.header.getBoundingClientRect().bottom;Math.abs(e)>1&&(this.$.table.scrollTop+=e,this._scrollHandler())}this._scrollingToIndex=!1}
/** @private */_effectiveSizeChanged(e){let t,i=0;// first visible (adjusted) index
if(this._iterateItems((e,s)=>{if(s===this._firstVisibleIndex){const s=this._physicalItems[e];t=s.index,i=s.getBoundingClientRect().top}}),this.items&&e<this.items.length&&(
// Size was reduced, scroll to 0 first
this._scrollTop=0),!Array.isArray(this.items)){
// Edge/IE seems to have the lowest maximum
const t=this._edge||this._ie?3e4:1e5;this.items={length:Math.min(e,t)}}this._accessIronListAPI(()=>super._itemsChanged({path:"items"})),this._virtualCount=Math.min(this.items.length,e)||0,0===this._scrollTop&&(this._accessIronListAPI(()=>this._scrollToIndex(Math.min(e-1,t))),this._iterateItems((e,s)=>{const r=this._physicalItems[e];// Restore keyboard focus to the right cell
if(r.index===t&&(this.$.table.scrollTop+=Math.round(r.getBoundingClientRect().top-i)),r.index===this._focusedItemIndex&&this._itemsFocusable&&this.$.items.contains(this.shadowRoot.activeElement)){const e=Array.from(this._itemsFocusable.parentElement.children).indexOf(this._itemsFocusable);r.children[e].focus()}})),this._assignModels(),requestAnimationFrame(()=>this._update()),this.__updateFooterPositioning(),this._ie&&(
// Workaround an IE flexbox bug where the rows would horizontally collapse
// whenever item count change toggles the scrollbar visibility (is tested)
this.$.table.style.display="block",setTimeout(()=>{this.$.table.style.display="flex",this._translateStationaryElements()}))}
/** @protected */_positionItems(){let e;this._adjustScrollPosition(),isNaN(this._physicalTop)&&(e=!0,this._physicalTop=0);let t=this._physicalTop;this._iterateItems((e,i)=>{this._physicalItems[e].style.transform=`translateY(${t}px)`,t+=this._physicalSizes[e]}),e&&this._scrollToIndex(0)}
/**
   * @param {number} count
   * @protected
   */_increasePoolIfNeeded(e){0===e&&this._scrollingToIndex||!this._canPopulate()||!this._effectiveSize||(this._initialPoolCreated?this._optPhysicalSize!==1/0&&(this._debounceIncreasePool=h.a.debounce(this._debounceIncreasePool,r.a,()=>{this._updateMetrics();const e=this._optPhysicalSize-this._physicalSize;let t=Math.ceil(e/this._physicalAverage);this._physicalCount+t>this._effectiveSize&&(
// Do not increase the physical item count above the this._effectiveSize
t=Math.max(0,this._effectiveSize-this._physicalCount)),this._physicalSize&&t>0&&this._optPhysicalSize!==1/0&&(super._increasePoolIfNeeded(t),// Ensure the rows are in order after increasing pool
this.__reorderChildNodes()),this.__flushPendingRecalculateColumnWidths()})):(this._initialPoolCreated=!0,super._increasePoolIfNeeded(25)))}
/** @private */__reorderChildNodes(){const e=Array.from(this.$.items.childNodes);!!e.reduce((e,t,i,s)=>{if(0===i||s[i-1].index===t.index-1)return e},!0)||e.sort((e,t)=>e.index-t.index).forEach(e=>this.$.items.appendChild(e))}
/** @private */_createPool(e){const t=document.createDocumentFragment(),i=this._createScrollerRows(e);i.forEach(e=>t.appendChild(e)),this._getRowTarget().appendChild(t);// Weird hack needed to get Safari to actually distribute slots
const r=this.querySelector("[slot]");if(r){const e=r.getAttribute("slot");r.setAttribute("slot","foo-bar"),r.setAttribute("slot",e)}return Object(s.a)(this,()=>this.notifyResize()),i}
/**
   * Assigns the data models to a given set of items.
   * @param {!Array<number>=} itemSet
   * @protected
   */_assignModels(e){
// Skip here if internal flag for preventing item updates is set
this._preventItemUpdates||this._iterateItems((e,t)=>{const i=this._physicalItems[e];this._toggleAttribute("hidden",t>=this._effectiveSize,i),this._updateScrollerItem(i,t+(this._vidxOffset||0))},e)}
/** @protected */_scrollHandler(){const e=this.$.table.scrollTop-this._scrollPosition;this._accessIronListAPI(super._scrollHandler);const t=this._vidxOffset;this._accessIronListAPI(()=>this._maxScrollTop)&&this._virtualCount<this._effectiveSize?this._adjustVirtualIndexOffset(e):this._vidxOffset=0,this._vidxOffset!==t&&this._update(),this._afterScroll()}
/** @private */_adjustVirtualIndexOffset(e){if(Math.abs(e)>1e4){if(this._noScale)return void(this._noScale=!1);const e=this.$.table.scrollTop/(this.$.table.scrollHeight-this.$.table.offsetHeight),t=e*this._effectiveSize;this._vidxOffset=Math.round(t-e*this._virtualCount)}else{
// Make sure user can always swipe/wheel scroll to the start and end
const e=this._vidxOffset||0,t=1e3,i=100;// At start
0===this._scrollTop?(this._vidxOffset=0,e!==this._vidxOffset&&super.scrollToIndex(0)):this.firstVisibleIndex<t&&this._vidxOffset>0&&(this._vidxOffset-=Math.min(this._vidxOffset,i),e!==this._vidxOffset&&super.scrollToIndex(this.firstVisibleIndex+(e-this._vidxOffset)),this._noScale=!0);// At end
const s=this._effectiveSize-this._virtualCount;this._scrollTop>=this._maxScrollTop&&this._maxScrollTop>0?(this._vidxOffset=s,e!==this._vidxOffset&&super.scrollToIndex(this._virtualCount)):this.firstVisibleIndex>this._virtualCount-t&&this._vidxOffset<s&&(this._vidxOffset+=Math.min(s-this._vidxOffset,i),e!==this._vidxOffset&&super.scrollToIndex(this.firstVisibleIndex-(this._vidxOffset-e)),this._noScale=!0)}}
/** @private */_accessIronListAPI(e){this._warnPrivateAPIAccessAsyncEnabled=!1;const t=e.apply(this);return this._debouncerWarnPrivateAPIAccess=h.a.debounce(this._debouncerWarnPrivateAPIAccess,r.a,()=>this._warnPrivateAPIAccessAsyncEnabled=!0),t}
/**
   * Allow iron-list to access its APIs from debounced callbacks without warns
   * @private
   */_debounceRender(e,t){super._debounceRender(()=>this._accessIronListAPI(e),t)}
/**
   * Warn when iron-list APIs are being accessed directly
   * @private
   */_warnPrivateAPIAccess(e){this._warnPrivateAPIAccessAsyncEnabled&&console.warn(`Accessing private API (${e})!`)}
/** @protected */_render(){this._accessIronListAPI(super._render)}
/** @private */_createFocusBackfillItem(){
/* Ignore */}
/** @private */_multiSelectionChanged(){
/* Ignore */}
/** @private */clearSelection(){
/* Ignore */}
/** @protected */_itemsChanged(){
/* Ignore */}
/** @private */_manageFocus(){
/* Ignore */}
/** @private */_removeFocusedItem(){
/* Ignore */}
/**
   * @return {number}
   * @protected
   */get _firstVisibleIndex(){return this._accessIronListAPI(()=>super.firstVisibleIndex)}
/**
   * @return {number}
   * @protected
   */get _lastVisibleIndex(){return this._accessIronListAPI(()=>super.lastVisibleIndex)}
/**
   * @param {number} index
   * @protected
   */_scrollToIndex(e){this._accessIronListAPI(()=>this.scrollToIndex(e))}
/** @private */get firstVisibleIndex(){return this._warnPrivateAPIAccess("firstVisibleIndex"),super.firstVisibleIndex}
/** @private */set firstVisibleIndex(e){this._warnPrivateAPIAccess("firstVisibleIndex"),super.firstVisibleIndex=e}
/** @private */get lastVisibleIndex(){return this._warnPrivateAPIAccess("lastVisibleIndex"),super.lastVisibleIndex}
/** @private */set lastVisibleIndex(e){this._warnPrivateAPIAccess("lastVisibleIndex"),super.lastVisibleIndex=e}
/** @private */updateViewportBoundaries(){this._warnPrivateAPIAccess("updateViewportBoundaries"),super.updateViewportBoundaries.apply(this,arguments)}
/** @protected */_resizeHandler(){super._resizeHandler(),Object(n.b)()}__isCreatingRows(){
// iron-list's _increasePoolIfNeeded function may have scheduled a debouncer
// that will re-invoke _increasePoolIfNeeded (in vaadin-grid-scroller)
const e=this._debouncers&&this._debouncers._increasePoolIfNeeded&&this._debouncers._increasePoolIfNeeded.isActive(),t=this._debounceIncreasePool&&this._debounceIncreasePool.isActive();// vaadin-grid-scroller's overridden _increasePoolIfNeeded may have scheduled a _debounceIncreasePool debouncer
// If either of the conditions are true, we consider the grid is still in the process of creating new rows
return e||t}}customElements.define(m.is,m)},
/***/nPeL:
/***/function(e,t,i){"use strict";
/* unused harmony export ItemCache */
/* harmony export (binding) */i.d(t,"a",(function(){return a}));
/* harmony import */var s=i("9nmN"),r=i("Y40L");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
const n=class e{
/**
   * @param {!HTMLElement} grid
   * @param {!ItemCache | undefined} parentCache
   * @param {!GridItem | undefined} parentItem
   */
constructor(e,t,i){
/** @type {!HTMLElement} */
this.grid=e,
/** @type {!ItemCache | undefined} */
this.parentCache=t,
/** @type {!GridItem | undefined} */
this.parentItem=i,
/** @type {object} */
this.itemCaches={},
/** @type {object} */
this.items={},
/** @type {number} */
this.effectiveSize=0,
/** @type {number} */
this.size=0,
/** @type {object} */
this.pendingRequests={}}
/**
   * @return {boolean}
   */isLoading(){return Boolean(Object.keys(this.pendingRequests).length||Object.keys(this.itemCaches).filter(e=>this.itemCaches[e].isLoading())[0])}
/**
   * @param {number} index
   * @return {!GridItem | undefined}
   */getItemForIndex(e){const{cache:t,scaledIndex:i}=this.getCacheAndIndex(e);return t.items[i]}updateSize(){this.effectiveSize=!this.parentItem||this.grid._isExpanded(this.parentItem)?this.size+Object.keys(this.itemCaches).reduce((e,t)=>{const i=this.itemCaches[t];return i.updateSize(),e+i.effectiveSize},0):0}
/**
   * @param {number} scaledIndex
   */ensureSubCacheForScaledIndex(t){if(!this.itemCaches[t]){const i=new e(this.grid,this,this.items[t]);this.itemCaches[t]=i,this.grid._loadPage(0,i)}}
/**
   * @param {number} index
   * @return {{cache: !ItemCache, scaledIndex: number}}
   */getCacheAndIndex(e){let t=e;const i=Object.keys(this.itemCaches);for(var s=0;s<i.length;s++){const e=Number(i[s]),r=this.itemCaches[e];if(t<=e)return{cache:this,scaledIndex:t};if(t<=e+r.effectiveSize)return r.getCacheAndIndex(t-e-1);t-=r.effectiveSize}return{cache:this,scaledIndex:t}}},a=e=>class extends e{static get properties(){return{
/**
       * Number of items fetched at a time from the dataprovider.
       * @attr {number} page-size
       * @type {number}
       */
pageSize:{type:Number,value:50,observer:"_pageSizeChanged"},
/**
       * Function that provides items lazily. Receives arguments `params`, `callback`
       *
       * `params.page` Requested page index
       *
       * `params.pageSize` Current page size
       *
       * `params.filters` Currently applied filters
       *
       * `params.sortOrders` Currently applied sorting orders
       *
       * `params.parentItem` When tree is used, and sublevel items
       * are requested, reference to parent item of the requested sublevel.
       * Otherwise `undefined`.
       *
       * `callback(items, size)` Callback function with arguments:
       *   - `items` Current page of items
       *   - `size` Total number of items. When tree sublevel items
       *     are requested, total number of items in the requested sublevel.
       *     Optional when tree is not used, required for tree.
       *
       * @type {GridDataProvider | null | undefined}
       */
dataProvider:{type:Object,notify:!0,observer:"_dataProviderChanged"},
/**
       * `true` while data is being requested from the data provider.
       */
loading:{type:Boolean,notify:!0,readOnly:!0,reflectToAttribute:!0},
/**
       * @type {!ItemCache}
       * @protected
       */
_cache:{type:Object,value:function(){return new n(this)}},
/**
       * Path to an item sub-property that identifies the item.
       * @attr {string} item-id-path
       */
itemIdPath:{type:String,value:null},
/**
       * An array that contains the expanded items.
       * @type {!Array<!GridItem>}
       */
expandedItems:{type:Object,notify:!0,value:()=>[]}}}static get observers(){return["_sizeChanged(size)","_itemIdPathChanged(itemIdPath)","_expandedItemsChanged(expandedItems.*)"]}
/** @private */_sizeChanged(e){const t=e-this._cache.size;this._cache.size+=t,this._cache.effectiveSize+=t,this._effectiveSize=this._cache.effectiveSize,this._increasePoolIfNeeded(0),this._debounceIncreasePool&&this._debounceIncreasePool.flush()}
/**
   * @param {number} index
   * @param {HTMLElement} el
   * @protected
   */_getItem(e,t){if(e>=this._effectiveSize)return;t.index=e;const{cache:i,scaledIndex:s}=this._cache.getCacheAndIndex(e),r=i.items[s];r?(this._toggleAttribute("loading",!1,t),this._updateItem(t,r),this._isExpanded(r)&&i.ensureSubCacheForScaledIndex(s)):(this._toggleAttribute("loading",!0,t),this._loadPage(this._getPageForIndex(s),i))}
/** @private */_expandedInstanceChangedCallback(e,t){void 0!==e.item&&(t?this.expandItem(e.item):this.collapseItem(e.item))}
/**
   * Returns a value that identifies the item. Uses `itemIdPath` if available.
   * Can be customized by overriding.
   * @param {!GridItem} item
   * @return {!GridItem | !unknown}
   */getItemId(e){return this.itemIdPath?this.get(this.itemIdPath,e):e}
/**
   * @param {!GridItem} item
   * @return {boolean}
   * @protected
   */_isExpanded(e){return this.__expandedKeys.has(this.getItemId(e))}
/** @private */_expandedItemsChanged(e){this.__cacheExpandedKeys(),this._cache.updateSize(),this._effectiveSize=this._cache.effectiveSize,this._assignModels()}
/** @private */_itemIdPathChanged(e){this.__cacheExpandedKeys()}
/** @private */__cacheExpandedKeys(){this.expandedItems&&(this.__expandedKeys=new Set,this.expandedItems.forEach(e=>{this.__expandedKeys.add(this.getItemId(e))}))}
/**
   * Expands the given item tree.
   * @param {!GridItem} item
   */expandItem(e){this._isExpanded(e)||this.push("expandedItems",e)}
/**
   * Collapses the given item tree.
   * @param {!GridItem} item
   */collapseItem(e){this._isExpanded(e)&&this.splice("expandedItems",this._getItemIndexInArray(e,this.expandedItems),1)}
/**
   * @param {number} index
   * @return {number}
   * @protected
   */_getIndexLevel(e){let{cache:t}=this._cache.getCacheAndIndex(e),i=0;for(;t.parentCache;)t=t.parentCache,i++;return i}
/**
   * @return {boolean}
   * @protected
   */_canPopulate(){return Boolean(this._hasData&&this._columnTree)}
/**
   * @param {number} page
   * @param {ItemCache} cache
   * @protected
   */_loadPage(e,t){
// make sure same page isn't requested multiple times.
if(!t.pendingRequests[e]&&this.dataProvider){this._setLoading(!0),t.pendingRequests[e]=!0;const i={page:e,pageSize:this.pageSize,sortOrders:this._mapSorters(),filters:this._mapFilters(),parentItem:t.parentItem};this._debounceIncreasePool&&this._debounceIncreasePool.flush(),this.dataProvider(i,(n,a)=>{void 0!==a?t.size=a:i.parentItem&&(t.size=n.length);const o=Array.from(this.$.items.children).map(e=>e._item);// Populate the cache with new items
n.forEach((i,s)=>{const r=e*this.pageSize+s;t.items[r]=i,this._isExpanded(i)&&o.indexOf(i)>-1&&
// Force synchronous data request for expanded item sub-cache
t.ensureSubCacheForScaledIndex(r)}),this._hasData=!0,delete t.pendingRequests[e],this._debouncerApplyCachedData=s.a.debounce(this._debouncerApplyCachedData,r.d.after(0),()=>{this._setLoading(!1),this._cache.updateSize(),this._effectiveSize=this._cache.effectiveSize,Array.from(this.$.items.children).filter(e=>!e.hidden).forEach(e=>{this._cache.getItemForIndex(e.index)&&this._getItem(e.index,e)}),this._increasePoolIfNeeded(0),this.__scrollToPendingIndex()}),this._cache.isLoading()||this._debouncerApplyCachedData.flush(),this.__flushPendingRecalculateColumnWidths()})}}
/**
   * @param {number} index
   * @return {number}
   * @private
   */_getPageForIndex(e){return Math.floor(e/this.pageSize)}
/**
   * Clears the cached pages and reloads data from dataprovider when needed.
   */clearCache(){this._cache=new n(this),Array.from(this.$.items.children).forEach(e=>{Array.from(e.children).forEach(e=>{
// Force data system to pick up subproperty changes
e._instance&&e._instance._setPendingProperty("item",{},!1)})}),this._cache.size=this.size||0,this._cache.updateSize(),this._hasData=!1,this._assignModels(),this._effectiveSize&&this._initialPoolCreated||this._loadPage(0,this._cache)}
/** @private */_pageSizeChanged(e,t){void 0!==t&&e!==t&&this.clearCache()}
/** @protected */_checkSize(){void 0===this.size&&0===this._effectiveSize&&console.warn("The <vaadin-grid> needs the total number of items in order to display rows. Set the total number of items to the `size` property, or provide the total number of items in the second argument of the `dataProvider`’s `callback` call.")}
/** @private */_dataProviderChanged(e,t){void 0!==t&&this.clearCache(),e&&this.items&&this.items.length&&
// Fixes possibly invalid cached lastVisibleIndex value in <iron-list>
this._scrollToIndex(this._firstVisibleIndex),this._ensureFirstPageLoaded(),this._debouncerCheckSize=s.a.debounce(this._debouncerCheckSize,r.d.after(2e3),this._checkSize.bind(this)),this._scrollHandler()}
/** @protected */_ensureFirstPageLoaded(){this._hasData||
// load data before adding rows to make sure they have content when
// rendered for the first time.
this._loadPage(0,this._cache)}
/**
   * @param {!GridItem} item1
   * @param {!GridItem} item2
   * @return {boolean}
   * @protected
   */_itemsEqual(e,t){return this.getItemId(e)===this.getItemId(t)}
/**
   * @param {!GridItem} item
   * @param {!Array<!GridItem>} array
   * @return {number}
   * @protected
   */_getItemIndexInArray(e,t){let i=-1;return t.forEach((t,s)=>{this._itemsEqual(t,e)&&(i=s)}),i}scrollToIndex(e){super.scrollToIndex(e),isNaN(e)||!this._cache.isLoading()&&this.clientHeight||(this.__pendingScrollToIndex=e)}__scrollToPendingIndex(){if(this.__pendingScrollToIndex&&this.$.items.children.length){const e=this.__pendingScrollToIndex;delete this.__pendingScrollToIndex,this._debounceIncreasePool&&this._debounceIncreasePool.flush(),this.scrollToIndex(e)}}}
/***/;
/**
 * @polymerMixin
 */},
/***/qu6e:
/***/function(e,t,i){"use strict";
/* unused harmony export ColumnBaseMixin */
/* harmony export (binding) */i.d(t,"a",(function(){return d}));
/* harmony import */var s=i("F3iu"),r=i("6hLg"),n=i("ZWVL"),a=i("3OGf"),o=i("9nmN"),l=i("Y40L");
/* harmony import */
/**
@license
Copyright (c) 2018 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const h=e=>class extends e{static get properties(){return{
/**
       * When set to true, the column is user-resizable.
       * @default false
       */
resizable:{type:Boolean,value:function(){if("vaadin-grid-column-group"===this.localName)return;const e=this.parentNode;return e&&"vaadin-grid-column-group"===e.localName&&e.resizable||!1}},
/**
       * @type {HTMLTemplateElement}
       * @protected
       */
_headerTemplate:{type:Object},
/**
       * @type {HTMLTemplateElement}
       * @protected
       */
_footerTemplate:{type:Object},
/**
       * When true, the column is frozen. When a column inside of a column group is frozen,
       * all of the sibling columns inside the group will get frozen also.
       * @type {boolean}
       */
frozen:{type:Boolean,value:!1},
/**
       * When set to true, the cells for this column are hidden.
       */
hidden:{type:Boolean},
/**
       * Text content to display in the header cell of the column.
       */
header:{type:String},
/**
       * Aligns the columns cell content horizontally.
       * Supported values: "start", "center" and "end".
       * @attr {start|center|end} text-align
       * @type {GridColumnTextAlign | null | undefined}
       */
textAlign:{type:String},
/**
       * @type {boolean}
       * @protected
       */
_lastFrozen:{type:Boolean,value:!1},
/** @protected */
_order:Number,
/** @private */
_reorderStatus:Boolean,
/**
       * @type {Array<!HTMLElement>}
       * @protected
       */
_emptyCells:Array,
/** @private */
_headerCell:Object,
/** @private */
_footerCell:Object,
/** @protected */
_grid:Object,
/**
       * Custom function for rendering the header content.
       * Receives two arguments:
       *
       * - `root` The header cell content DOM element. Append your content to it.
       * - `column` The `<vaadin-grid-column>` element.
       *
       * @type {GridHeaderFooterRenderer | null | undefined}
       */
headerRenderer:Function,
/**
       * Custom function for rendering the footer content.
       * Receives two arguments:
       *
       * - `root` The footer cell content DOM element. Append your content to it.
       * - `column` The `<vaadin-grid-column>` element.
       *
       * @type {GridHeaderFooterRenderer | null | undefined}
       */
footerRenderer:Function}}static get observers(){return["_widthChanged(width, _headerCell, _footerCell, _cells.*)","_frozenChanged(frozen, _headerCell, _footerCell, _cells.*)","_flexGrowChanged(flexGrow, _headerCell, _footerCell, _cells.*)","_pathOrHeaderChanged(path, header, _headerCell, _footerCell, _cells.*, renderer, headerRenderer, _bodyTemplate, _headerTemplate)","_textAlignChanged(textAlign, _cells.*, _headerCell, _footerCell)","_orderChanged(_order, _headerCell, _footerCell, _cells.*)","_lastFrozenChanged(_lastFrozen)","_setBodyTemplateOrRenderer(_bodyTemplate, renderer, _cells, _cells.*)","_setHeaderTemplateOrRenderer(_headerTemplate, headerRenderer, _headerCell)","_setFooterTemplateOrRenderer(_footerTemplate, footerRenderer, _footerCell)","_resizableChanged(resizable, _headerCell)","_reorderStatusChanged(_reorderStatus, _headerCell, _footerCell, _cells.*)","_hiddenChanged(hidden, _headerCell, _footerCell, _cells.*)"]}
/** @protected */connectedCallback(){super.connectedCallback(),this._bodyTemplate&&(this._bodyTemplate.templatizer._grid=this._grid),this._headerTemplate&&(this._headerTemplate.templatizer._grid=this._grid),this._footerTemplate&&(this._footerTemplate.templatizer._grid=this._grid),this._templateObserver.flush(),this._bodyTemplate||
// The observer might not have triggered if the tag is empty. Run manually.
this._templateObserver.callback(),requestAnimationFrame(()=>{this._allCells.forEach(e=>{e._content.parentNode||this._grid&&this._grid.appendChild(e._content)})})}
/** @protected */disconnectedCallback(){super.disconnectedCallback(),requestAnimationFrame(()=>{this._findHostGrid()||this._allCells.forEach(e=>{e._content.parentNode&&e._content.parentNode.removeChild(e._content)})}),this._gridValue=void 0}
/**
   * @return {!GridElement | undefined}
   * @protected
   */_findHostGrid(){let e=this;// Custom elements extending grid must have a specific localName
for(;e&&!/^vaadin.*grid(-pro)?$/.test(e.localName);)e=e.assignedSlot?e.assignedSlot.parentNode:e.parentNode;return e||void 0}
/**
   * @return {!GridElement | undefined}
   * @protected
   */get _grid(){return this._gridValue||(this._gridValue=this._findHostGrid()),this._gridValue}
/**
   * @return {!Array<!HTMLElement>}
   * @protected
   */get _allCells(){return[].concat(this._cells||[]).concat(this._emptyCells||[]).concat(this._headerCell).concat(this._footerCell).filter(e=>e)}constructor(){super(),this._templateObserver=new r.a(this,e=>{this._headerTemplate=this._prepareHeaderTemplate(),this._footerTemplate=this._prepareFooterTemplate(),this._bodyTemplate=this._prepareBodyTemplate()})}
/**
   * @return {HTMLTemplateElement}
   * @protected
   */_prepareHeaderTemplate(){return this._prepareTemplatizer(this._findTemplate(!0)||null,{})}
/**
   * @return {HTMLTemplateElement}
   * @protected
   */_prepareFooterTemplate(){return this._prepareTemplatizer(this._findTemplate(!1,!0)||null,{})}
/**
   * @return {HTMLTemplateElement}
   * @protected
   */_prepareBodyTemplate(){return this._prepareTemplatizer(this._findTemplate()||null)}
/**
   * @param {HTMLTemplateElement} template
   * @param {object} instanceProps
   * @return {HTMLTemplateElement}
   * @protected
   */_prepareTemplatizer(e,t){if(e&&!e.templatizer){const i=new a.a;i._grid=this._grid,i.dataHost=this.dataHost,i._instanceProps=t||i._instanceProps,i.template=e,e.templatizer=i}return e}
/** @protected */_renderHeaderAndFooter(){this.headerRenderer&&this._headerCell&&this.__runRenderer(this.headerRenderer,this._headerCell),this.footerRenderer&&this._footerCell&&this.__runRenderer(this.footerRenderer,this._footerCell)}
/** @private */__runRenderer(e,t,i){const s=[t._content,this];i&&i.item&&s.push(i),e.apply(this,s)}
/** @private */__setColumnTemplateOrRenderer(e,t,i){
// no renderer or template needed in a hidden column
if(!this.hidden){if(e&&t)throw new Error("You should only use either a renderer or a template");i.forEach(i=>{const s=i.parentElement;// When a column is made hidden and shown again, in some instances it breaks rendering of rows for grid
// this happens when parent element of cell is null, which might not be set correctly during rendering
// the newly shown column, this check simply avoid that case
if(!s)return;const r=this._grid.__getRowModel(s);if(t)i._renderer=t,(r.item||t===this.headerRenderer||t===this.footerRenderer)&&this.__runRenderer(t,i,r);else if(i._template!==e){i._template=e,i._content.innerHTML="",e.templatizer._grid=e.templatizer._grid||this._grid;const t=e.templatizer.createInstance();i._content.appendChild(t.root),i._instance=t,r.item&&i._instance.setProperties(r)}})}}
/** @private */_setBodyTemplateOrRenderer(e,t,i,s){(e||t)&&i&&this.__setColumnTemplateOrRenderer(e,t,i)}
/** @private */_setHeaderTemplateOrRenderer(e,t,i){(e||t)&&i&&this.__setColumnTemplateOrRenderer(e,t,[i])}
/** @private */_setFooterTemplateOrRenderer(e,t,i){(e||t)&&i&&(this.__setColumnTemplateOrRenderer(e,t,[i]),this._grid&&this._grid.__updateHeaderFooterRowVisibility(i.parentElement))}
/**
   * @param {boolean} header
   * @param {boolean} footer
   * @return {HTMLTemplateElement}
   * @protected
   */_selectFirstTemplate(e=!1,t=!1){return r.a.getFlattenedNodes(this).filter(i=>"template"===i.localName&&i.classList.contains("header")===e&&i.classList.contains("footer")===t)[0]}
/**
   * @param {boolean} header
   * @param {boolean} footer
   * @return {HTMLTemplateElement}
   * @protected
   */_findTemplate(e,t){const i=this._selectFirstTemplate(e,t);return i&&this.dataHost&&(
// set dataHost to the context where template has been defined
i._rootDataHost=this.dataHost._rootDataHost||this.dataHost),i}
/** @private */_flexGrowChanged(e,t,i,s){this.parentElement&&this.parentElement._columnPropChanged&&this.parentElement._columnPropChanged("flexGrow"),this._allCells.forEach(t=>t.style.flexGrow=e)}
/** @private */_orderChanged(e,t,i,s){this._allCells.forEach(t=>t.style.order=e)}
/** @private */_widthChanged(e,t,i,s){this.parentElement&&this.parentElement._columnPropChanged&&this.parentElement._columnPropChanged("width"),this._allCells.forEach(t=>t.style.width=e),// Force a reflow to workaround browser issues causing double scrollbars to grid
// https://github.com/vaadin/vaadin-grid/issues/1586
this._grid&&this._grid.__forceReflow&&this._grid.__forceReflow()}
/** @private */_frozenChanged(e,t,i,s){this.parentElement&&this.parentElement._columnPropChanged&&this.parentElement._columnPropChanged("frozen",e),this._allCells.forEach(t=>this._toggleAttribute("frozen",e,t)),this._grid&&this._grid._frozenCellsChanged&&this._grid._frozenCellsChanged()}
/** @private */_lastFrozenChanged(e){this._allCells.forEach(t=>this._toggleAttribute("last-frozen",e,t)),this.parentElement&&this.parentElement._columnPropChanged&&(this.parentElement._lastFrozen=e)}
/**
   * @param {string | undefined} path
   * @param {string | undefined} header
   * @param {!HTMLTableCellElement | undefined} headerCell
   * @param {!HTMLTableCellElement | undefined} footerCell
   * @param {!object | undefined} cells
   * @param {GridBodyRenderer | undefined} renderer
   * @param {GridHeaderFooterRenderer | undefined} headerRenderer
   * @param {HTMLTemplateElement | undefined} bodyTemplate
   * @param {HTMLTemplateElement | undefined} headerTemplate
   * @protected
   */_pathOrHeaderChanged(e,t,i,s,r,n,a,o,l){const h=void 0!==t;if(!a&&!l&&h&&i&&this.__setTextContent(i._content,t),e&&r.value){if(!n&&!o){const t=(t,i,{item:s})=>this.__setTextContent(t,this.get(e,s));this.__setColumnTemplateOrRenderer(void 0,t,r.value)}a||l||h||!i||null===t||this.__setTextContent(i._content,this._generateHeader(e))}i&&this._grid&&this._grid.__updateHeaderFooterRowVisibility(i.parentElement)}
/** @private */__setTextContent(e,t){e.textContent!==t&&(e.textContent=t)}
/**
   * @param {string} path
   * @return {string}
   * @protected
   */_generateHeader(e){return e.substr(e.lastIndexOf(".")+1).replace(/([A-Z])/g,"-$1").toLowerCase().replace(/-/g," ").replace(/^./,e=>e.toUpperCase())}
/**
   * @param {string} name
   * @param {boolean} bool
   * @param {!Element} node
   * @protected
   */_toggleAttribute(e,t,i){i.hasAttribute(e)===!t&&(t?i.setAttribute(e,""):i.removeAttribute(e))}
/** @private */_reorderStatusChanged(e,t,i,s){this._allCells.forEach(t=>t.setAttribute("reorder-status",e))}
/** @private */_resizableChanged(e,t){void 0!==e&&void 0!==t&&t&&[t].concat(this._emptyCells).forEach(t=>{if(t){const i=t.querySelector('[part~="resize-handle"]');if(i&&t.removeChild(i),e){const e=document.createElement("div");e.setAttribute("part","resize-handle"),t.appendChild(e)}}})}
/** @private */_textAlignChanged(e,t,i,s){if(void 0===e)return;if(-1===["start","end","center"].indexOf(e))return void console.warn('textAlign can only be set as "start", "end" or "center"');let r;"ltr"===getComputedStyle(this._grid).direction?"start"===e?r="left":"end"===e&&(r="right"):"start"===e?r="right":"end"===e&&(r="left"),this._allCells.forEach(t=>{t._content.style.textAlign=e,getComputedStyle(t._content).textAlign!==e&&(t._content.style.textAlign=r)})}
/** @private */_hiddenChanged(e,t,i,s){this.parentElement&&this.parentElement._columnPropChanged&&this.parentElement._columnPropChanged("hidden",e),!!e!=!!this._previousHidden&&this._grid&&(!0===e&&this._allCells.forEach(e=>{e._content.parentNode&&e._content.parentNode.removeChild(e._content)}),this._grid._debouncerHiddenChanged=o.a.debounce(this._grid._debouncerHiddenChanged,l.a,()=>{this._grid&&this._grid._renderColumnTree&&this._grid._renderColumnTree(this._grid._columnTree)}),this._grid._updateLastFrozen&&this._grid._updateLastFrozen(),this._grid.notifyResize&&this._grid.notifyResize(),this._grid._resetKeyboardNavigation&&this._grid._resetKeyboardNavigation()),this._previousHidden=e}}
/**
 * A `<vaadin-grid-column>` is used to configure how a column in `<vaadin-grid>`
 * should look like.
 *
 * See `<vaadin-grid>` documentation and demos for instructions and examples on how
 * to configure the `<vaadin-grid-column>`.
 * ```
 *
 * @extends PolymerElement
 * @mixes ColumnBaseMixin
 */;class d extends(h(Object(n.a)(s.a))){static get is(){return"vaadin-grid-column"}static get properties(){return{
/**
       * Width of the cells for this column.
       */
width:{type:String,value:"100px"},
/**
       * Flex grow ratio for the cell widths. When set to 0, cell width is fixed.
       * @attr {number} flex-grow
       * @type {number}
       */
flexGrow:{type:Number,value:1},
/**
       * Custom function for rendering the cell content.
       * Receives three arguments:
       *
       * - `root` The cell content DOM element. Append your content to it.
       * - `column` The `<vaadin-grid-column>` element.
       * - `model` The object with the properties related with
       *   the rendered item, contains:
       *   - `model.index` The index of the item.
       *   - `model.item` The item.
       *   - `model.expanded` Sublevel toggle state.
       *   - `model.level` Level of the tree represented with a horizontal offset of the toggle button.
       *   - `model.selected` Selected state.
       *
       * @type {GridBodyRenderer | null | undefined}
       */
renderer:Function,
/**
       * Path to an item sub-property whose value gets displayed in the column body cells.
       * The property name is also shown in the column header if an explicit header or renderer isn't defined.
       */
path:{type:String},
/**
       * Automatically sets the width of the column based on the column contents when this is set to `true`.
       *
       * For performance reasons the column width is calculated automatically only once when the grid items
       * are rendered for the first time and the calculation only considers the rows which are currently
       * rendered in DOM (a bit more than what is currently visible). If the grid is scrolled, or the cell
       * content changes, the column width might not match the contents anymore.
       *
       * Hidden columns are ignored in the calculation and their widths are not automatically updated when
       * you show a column that was initially hidden.
       *
       * You can manually trigger the auto sizing behavior again by calling `grid.recalculateColumnWidths()`.
       *
       * The column width may still grow larger when `flexGrow` is not 0.
       * @attr {boolean} auto-width
       * @type {boolean}
       */
autoWidth:{type:Boolean,value:!1},
/**
       * @type {HTMLTemplateElement}
       * @protected
       */
_bodyTemplate:{type:Object},
/**
       * @type {Array<!HTMLElement>}
       * @protected
       */
_cells:Array}}}customElements.define(d.is,d)},
/***/wS1x:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return o}));
/* harmony import */var s=i("6hLg"),r=i("9nmN"),n=i("Y40L"),a=i("F3iu");
/* harmony import */
/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
/**
 * @polymerMixin
 */
const o=e=>class extends e{
/** @protected */
ready(){super.ready(),this._addNodeObserver()}
/** @private */_hasColumnGroups(e){for(let t=0;t<e.length;t++)if("vaadin-grid-column-group"===e[t].localName)return!0;return!1}
/**
   * @param {!GridColumnGroupElement} el
   * @return {!Array<!GridColumnElement>}
   * @protected
   */_getChildColumns(e){return s.a.getFlattenedNodes(e).filter(this._isColumnElement)}
/** @private */_flattenColumnGroups(e){return e.map(e=>"vaadin-grid-column-group"===e.localName?this._getChildColumns(e):[e]).reduce((e,t)=>e.concat(t),[])}
/** @private */_getColumnTree(){for(var e=[],t=s.a.getFlattenedNodes(this).filter(this._isColumnElement);e.push(t),this._hasColumnGroups(t);)t=this._flattenColumnGroups(t);return e}
/** @protected */_updateColumnTree(){var e=this._getColumnTree();this._arrayEquals(e,this._columnTree)||(this._columnTree=e)}
/** @private */_addNodeObserver(){this._observer=new s.a(this,e=>{const t=e.addedNodes.filter(e=>"template"===e.localName&&e.classList.contains("row-details"))[0];t&&this._rowDetailsTemplate!==t&&(this._rowDetailsTemplate=t);const i=e=>e.filter(this._isColumnElement).length>0;if(i(e.addedNodes)||i(e.removedNodes)){const t=e.removedNodes.reduce((e,t)=>e.concat(t._allCells),[]),i=e=>t.filter(t=>t._content.contains(e)).length;this.__removeSorters(this._sorters.filter(i)),this.__removeFilters(this._filters.filter(i)),this._updateColumnTree()}this._debouncerCheckImports=r.a.debounce(this._debouncerCheckImports,n.d.after(2e3),this._checkImports.bind(this)),this._ensureFirstPageLoaded()})}
/** @private */_arrayEquals(e,t){if(!e||!t||e.length!=t.length)return!1;for(var i=0,s=e.length;i<s;i++)
// Check if we have nested arrays
if(e[i]instanceof Array&&t[i]instanceof Array){
// recurse into the nested arrays
if(!this._arrayEquals(e[i],t[i]))return!1}else if(e[i]!=t[i])return!1;return!0}
/** @protected */_checkImports(){["vaadin-grid-column-group","vaadin-grid-filter","vaadin-grid-filter-column","vaadin-grid-tree-toggle","vaadin-grid-selection-column","vaadin-grid-sort-column","vaadin-grid-sorter"].forEach(e=>{var t=this.querySelector(e);!t||t instanceof a.a||console.warn(`Make sure you have imported the required module for <${e}> element.`)})}
/** @protected */_updateFirstAndLastColumn(){Array.from(this.shadowRoot.querySelectorAll("tr")).forEach(e=>this._updateFirstAndLastColumnForRow(e))}
/**
   * @param {!HTMLElement} row
   * @protected
   */_updateFirstAndLastColumnForRow(e){Array.from(e.querySelectorAll('[part~="cell"]:not([part~="details-cell"])')).sort((e,t)=>e._column._order-t._column._order).forEach((e,t,i)=>{this._toggleAttribute("first-column",0===t,e),this._toggleAttribute("last-column",t===i.length-1,e)})}
/**
   * @param {!Node} node
   * @return {boolean}
   * @protected
   */_isColumnElement(e){return e.nodeType===Node.ELEMENT_NODE&&/\bcolumn\b/.test(e.localName)}}
/***/}}]);